/* ************************ */
/* VARIABLES (global scope) */
/* ************************ */
/* general purpose */
var output = [];
var l_user = [];
var sid;
var devsystem;
var cartSumByID_EUR = new Array();
var cartSumByID_EUR_tax = new Array();
var addCartSumArray = new Array();
var price_edit_decimal_separator;
var cartimg;
var cartimg_pref;
var messageBoxTopDistance, messageBoxLeftTopDistance, messageBoxRightTopDistance;
var animationShowSpeed = 600;
var animationHideSpeed = 300;
var animationDelay = 300;
var animateTimeout = 0;

/* @ generate Path for images */
var done = false;
var pathParts = window.location.pathname.split('/');
if (!mainURL) {
    var mainURL = window.location.protocol + '//' + window.location.host;
    for (var i = 0; i < pathParts.length; i++) {
        if (pathParts[i] === 'cat' || pathParts[i] === 'eprocure') {
            mainURL += pathParts[i] + '/';
            done = true;
        }
        if (!done) {
            mainURL += pathParts[i] + '/';
        }
    }
}

/* ********* */
/* FUNCTIONS */

/* ********* */

/**
 * Call once at beginning to ensure your app can safely call console.log() and
 * console.dir(), even on browsers that don't support it.  You may not get useful
 * logging on those browers, but at least you won't generate errors.
 *
 * @param  alertFallback - if 'true', all logs become alerts, if necessary.
 *   (not usually suitable for production)
 */
function fixConsole(alertFallback) {
    if (typeof console === "undefined") {
        console = {}; // define it if it doesn't exist already
    }
    if (typeof console.log === "undefined") {
        if (alertFallback) {
            console.log = function (msg) {
                alert(msg);
            };
        } else {
            console.log = function () {
            };
        }
    }
    if (typeof console.dir === "undefined") {
        if (alertFallback) {
            // THIS COULD BE IMPROVED… maybe list all the object properties?
            console.dir = function (obj) {
                alert("DIR: " + obj);
            };
        } else {
            console.dir = function () {
            };
        }
    }
    if (typeof console.time === "undefined") {
        if (alertFallback) {
            console.time = function (msg) {
                alert(msg);
            };
        } else {
            console.time = function () {
            };
        }
    }
    if (typeof console.timeEnd === "undefined") {
        if (alertFallback) {
            console.timeEnd = function (msg) {
                alert(msg);
            };
        } else {
            console.timeEnd = function () {
            };
        }
    }
    if (typeof console.warn === "undefined") {
        if (alertFallback) {
            console.warn = function (msg) {
                alert(msg);
            };
        } else {
            console.warn = function () {
            };
        }
    }
}

function addWindowOnloadEvent(funct) {
    var oldOnLoad = window.onload;

    if (typeof window.onload != 'function') {
        window.onload = funct;
    } else {
        window.onload = function () {
            if (oldOnLoad) {
                oldOnLoad();
            }
            funct();
        }
    }
}


function setSearchMode(mode) {
    document.quicksearch.target = "";
    if (document.quicksearch.errors !== undefined)
        document.quicksearch.error.value = '1';
    document.quicksearch.searchmode.value = mode;
    if (mode == 'normal') {
        document.quicksearch.herstellername.value = '';
    }
    document.quicksearch.submit();
}

function setAutoFocus(elementId) {
    document.getElementById(elementId).focus();
}

function IsImageOk(img) {
    /* 
     added by BA: first check if object exists and is accessable
     */
    if (!img) {
        return false;
    }

    /* 
     During the onload event, IE correctly identifies any images that
     weren't downloaded as not complete. Others should too. Gecko-based
     browsers act like NS4 in that they report this incorrectly.
     */
    if (!img.complete) {
        /* IE9 has a bug here - due to a new preload/caching feature */
        if (ie9) {
            /* try getting file again */
            var tmpImg = new Image();
            tmpImg.src = img.src;
            if (tmpImg && tmpImg.complete) {
                img = tmpImg;
                return true;
            }
        }

        return false;
    }

    /* 
     However, they do have two very useful properties: naturalWidth and
     naturalHeight. These give the true size of the image. If it failed
     to load, either of these should be zero.
     */
    if (img.naturalWidth && typeof img.naturalWidth != "undefined" && img.naturalWidth == 0) {
        return false;
    }
    /* if Mozilla Firefox; check this too */
    else if (navigator && navigator.appCodeName && navigator.appCodeName == 'Mozilla' && navigator.appName && navigator.appName == 'Netscape' && !img.naturalWidth) {
        return false;
    }

    /* No other way of checking: assume it's ok. */
    return true;
}

function setAktivClass(elem_id) {
    $('.aktiv').removeClass('aktiv');
    $('#' + elem_id).addClass('aktiv');
}

function setExplain() {
    document.quicksearch.target = "";
    if (document.quicksearch.explain.value == "1") {
        document.quicksearch.explain.value = "0";
    } else {
        document.quicksearch.explain.value = "1";
    }
    document.quicksearch.submit();
}

function cartLoadAddressForm(location_sub_id) {
    if (location_sub_id != "")
        document.loadaddress.location_sub_id.value = location_sub_id;
    document.loadaddress.submit();
}

function showArticleOrders(artid, mode, filter) {

    if (mode == 'Y') {

        toggleBox('article_orders_show_' + artid, 0);
        toggleBox('article_orders_hide_' + artid, 1);
        $.ajax(
            {
                url: "ajax-backend/showAllOrdersPerArticle.php?showcartsartid=" + artid,
                type: 'post',
                data: "sid=" + sid + filter,
                success: function (data) {
                    var articleData = $("#detailRow" + artid);
                    $(articleData).parent().parent().show();
                    $(articleData).slideUp(0);
                    $(articleData).html(data).slideDown("slow");
                },
                error: function () {
                    alert(output['t_dies_ist_noch_keine_bestellung']);
                }
            });
    } else if (mode == 'N') {
        toggleBox('article_orders_show_' + artid, 1);
        toggleBox('article_orders_hide_' + artid, 0);

        $("#detailRow" + artid).slideUp("fast", function () {
            $(this).html("");
            $(this).parent().parent().hide();
        });
    }
}

function showClusterArticles(cluster, showHideName, cartarticleIds, mode) {
    if (mode == 'Y') {
        toggleBox('cluster_orders_show_' + showHideName, 0);
        toggleBox('cluster_orders_hide_' + showHideName, 1);
        $.ajax(
            {
                url: "ajax-backend/showAllPositionsPerCluster.php?cartarticleIds=" + cartarticleIds,
                type: 'post',
                data: "sid=" + sid,
                success: function (data) {
                    var clusterData = $("#detailRow" + showHideName);
                    $(clusterData).parent().parent().show();
                    $(clusterData).slideUp(0);
                    $(clusterData).html(data).slideDown("slow");
                },
                error: function () {
                    alert(output['t_dies_ist_noch_keine_bestellung']);
                }
            });
    } else if (mode == 'N') {
        toggleBox('cluster_orders_show_' + showHideName, 1);
        toggleBox('cluster_orders_hide_' + showHideName, 0);

        $("#detailRow" + showHideName).slideUp("fast", function () {
            $(this).html("");
            $(this).parent().parent().hide();
        });
    }
}

function addToVmiCart(vmiartnr, amount) {
    document.addtovmicart.target = "";
    document.addtovmicart.addtovmicartvmiartid.value = vmiartnr;
    document.addtovmicart.addtovmicartamount.value = amount;
    document.addtovmicart.submit();
}

function delFromCart(artnr) {
    document.delfromcart.target = "";
    document.delfromcart.delfromcartartid.value = artnr;
    document.delfromcart.submit();
}

function delArticlesFromCart(artnrs) {
    document.cartform.target = "";
    document.cartform.delfromcartartids.value = artnrs;
    document.cartform.artlistaction.value = 'delfromcartartids';
    submitFormGreyOut(document.cartform);
}

function assignFreetextSellerToAllFreetextPositions(articleId) {
    document.cartform.target = "";
    document.cartform.assignAllFreetextPositionsFromArticleId.value = articleId;
    document.cartform.artlistaction.value = 'assignFreetextSellerToAllFreetextPositions';
    submitFormGreyOut(document.cartform);
}

function ArticlesFromCartToAstras(artnrs) {
    document.cartform.target = "";
    document.cartform.astrascartartids.value = artnrs;
    document.cartform.artlistaction.value = 'fromcarttoastrascartartids';
    submitFormGreyOut(document.cartform);
}

function delFromOrdertrack(artnr) {
    document.delfromordertrack.target = "";
    document.delfromordertrack.delfromordertrackartid.value = artnr;
    document.delfromordertrack.submit();
}

function updateCartAmounts() {
    document.cartform.target = "";
    document.cartform.artlistaction.value = 'updatecartamounts';
    submitFormGreyOut(document.cartform);
}

function updatePriceEdits() {
    document.cartform.target = "";
    document.cartform.artlistaction.value = 'updatepriceedits';
    submitFormGreyOut(document.cartform);
}

function updateCartarticleDeliverydate(cartarticle_id) {
    document.cartform.target = "";
    document.cartform.artlistaction.value = 'updatecartarticledeliverydate';
    document.cartform.updatecartarticledeliverydate_id.value = cartarticle_id;
    submitFormGreyOut(document.cartform);
}

function updateCartAmounts3(cart_id) {
    document.cartform.target = "";
    document.cartform.updatecartamounts_cartid.value = cart_id;
    document.cartform.jumpto.value = 'showcart_jumpto_' + cart_id;
    document.cartform.artlistaction.value = 'updatecartamounts';
    submitFormGreyOut(document.cartform);
}

function gotoCheckOut() {
    document.cartform.target = "";
    document.cartform.artlistaction.value = 'gotocheckout';
    document.cartform.displaymenu.value = 'cart';
    submitFormGreyOut(document.cartform);
    replaceOnLoadGIF();
}

function submitCartOrder(assignmentmode, displaymenu, clickObject) {
    if (clickObject != null) {
        clickObject.onclick = null;
    }
    disablePageOnDataLoad();
    document.cartform.target = "";
    document.cartform.artlistaction.value = 'submitcartorder';
    document.cartform.assignmentmode.value = assignmentmode;
    document.cartform.displaymenu.value = displaymenu;
    submitFormGreyOut(document.cartform);
}

function assigntoposition() {
    document.cartform.target = "";
    document.cartform.artlistaction.value = 'assigntoposition';
    document.cartform.displaymenu.value = 'cart';
    submitFormGreyOut(document.cartform);
}

function addassignment(cartarticleid, asstype) {
    document.cartform.target = "";
    document.cartform.artlistaction.value = 'assigntoposition';
    /* document.cartform.displaymenu.value = 'cart' ; */
    document.cartform.addcartarticleid.value = cartarticleid;
    document.cartform.addcartarticletype.value = asstype;
    submitFormGreyOut(document.cartform);
}

function copycartposition(cartarticleid) {
    document.cartform.target = "";
    document.cartform.artlistaction.value = 'copycartposition';
    document.cartform.copycartarticleid.value = cartarticleid;
    submitFormGreyOut(document.cartform);
}

function addassignment_temp(addcartarticleid, seller_id, chargetype) {
    document.cartform.target = "";
    document.cartform.addcartarticleid_temp.value = addcartarticleid;
    document.cartform.addassignment_temp_seller_id.value = seller_id;
    document.cartform.addassignment_temp_chargetype.value = chargetype;
    submitFormGreyOut(document.cartform);
}

function deleteassignment(cartarticleid) {
    document.cartform.target = "";
    document.cartform.artlistaction.value = 'assigntoposition';
    /* document.cartform.displaymenu.value = 'cart' ; */
    document.cartform.deletecartarticleid.value = cartarticleid;
    submitFormGreyOut(document.cartform);
}

function deleteassignment_temp(cartarticleid) {
    document.cartform.target = "";
    document.cartform.artlistaction.value = 'assigntoposition';
    /* document.cartform.displaymenu.value = 'cart' ; */
    document.cartform.deletecartarticleid_temp.value = cartarticleid;
    submitFormGreyOut(document.cartform);
}

function acceptPreselection() {
    for (var x = 0; x < document.cartform.elements.length; x++) {
        var y = document.cartform.elements[x];
        if (y.name.substring(0, 10) == document.cartform.suggest_kontierung.value) {
            y.value = document.cartform.suggest_value.value;
        }
        if (y.name.substring(0, 13) == document.cartform.suggest_kontierung.value) {
            y.value = document.cartform.suggest_value.value;
        }
        if (y.name.substring(0, 9) == document.cartform.suggest_kontierung.value) {
            y.value = document.cartform.suggest_value.value;
        }
        if (y.name.substring(0, 15) == 'temp_' + document.cartform.suggest_kontierung.value) {
            y.value = document.cartform.suggest_value.value;
        }
        if (y.name.substring(0, 18) == 'temp_' + document.cartform.suggest_kontierung.value) {
            y.value = document.cartform.suggest_value.value;
        }
        if (y.name.substring(0, 14) == 'temp_' + document.cartform.suggest_kontierung.value) {
            y.value = document.cartform.suggest_value.value;
        }
    }
}

function checkMondatoryAddonList(className, checkAgainstDiv) {
    var error = [];
    $("." + className).each(function () {

        var valueInput = $('#' + checkAgainstDiv + $(this).attr('data_id')).val();
        console.log(valueInput);
        console.log(this.value);
        if (parseInt(valueInput) && this.value == '') {
            error.push($(this).attr('data_message'));
        }

    });

    if (error.length > 0) {
        alert(output.e_folgende_felder_mussen_befult_werden + ": \n" + error.join(", \n"));
        return false;
    } else {
        return true;
    }
}

function checkTreeMinMax(id, treemode) {

    var obj_min;
    var obj_max;
    var obj_amount;

    var min_amount;
    var max_amount;
    var amount_amount;

    if (treemode == 'addon') {
        return true;
    }

    obj_amount = document.getElementsByName('addon_' + id)[0];
    obj_min = document.getElementsByName('addon_min_' + id)[0];
    obj_max = document.getElementsByName('addon_max_' + id)[0];
    obj_default = document.getElementsByName('addon_default_' + id)[0];

    if (isNaN(obj_amount.value)) {
        alert(document.addtocart.error_default.value);
        obj_amount.value = obj_default.value;
    } else {
        amount_amount = obj_amount.value * 1;
        min_amount = obj_min.value * 1;
        max_amount = obj_max.value * 1;

        if (amount_amount < 0) {
            alert(document.addtocart.error_default.value);
            obj_amount.value = obj_default.value;
        } else if (min_amount != 0 && amount_amount < min_amount) {
            alert(document.addtocart.error_min.value);
            obj_amount.value = min_amount;

        } else if (max_amount != 0 && amount_amount > max_amount) {
            alert(document.addtocart.error_max.value);
            obj_amount.value = max_amount;

        }
    }
    return true;
}

function runde(x, n) {
    if (n < 1 || n > 14)
        return false;
    var e = Math.pow(10, n);
    var k = (Math.round(x * e) / e).toString();
    if (k.indexOf('.') == -1)
        k += '.';
    k += e.toString().substring(1);
    return k.substring(0, k.indexOf('.') + n + 1);
}

function setSuggestionType() {
    if (document.cartform.suggest_kontierung.value == 'projectnumber') {
        document.cartform.type.value = 'a';
        document.cartform.partner.value = document.cartform.partner_id.value;
        for (var x = 0; x < document.cartform.elements.length; x++) {
            var y = document.cartform.elements[x];

            if (y.name.substring(0, 1) == 'x') {
                y.value = '<<';

            }
            if (y.name.substring(0, 1) == 'y') {
                y.value = '';
            }
            if (y.name.substring(0, 1) == 'z') {
                y.value = '';
            }
        }
    }
    if (document.cartform.suggest_kontierung.value == 'pspnumber') {
        document.cartform.type.value = 'p';
        document.cartform.partner.value = document.cartform.partner_id.value;
        for (var x = 0; x < document.cartform.elements.length; x++) {
            var y = document.cartform.elements[x];

            if (y.name.substring(0, 1) == 'x') {
                y.value = '';

            }
            if (y.name.substring(0, 1) == 'y') {
                y.value = '<<';
            }
            if (y.name.substring(0, 1) == 'z') {
                y.value = '';
            }
        }
    }
    if (document.cartform.suggest_kontierung.value == 'costcenter') {
        document.cartform.type.value = document.cartform.webuser_id.value;
        document.cartform.partner.value = '-1';
        for (var x = 0; x < document.cartform.elements.length; x++) {
            var y = document.cartform.elements[x];

            if (y.name.substring(0, 1) == 'x') {
                y.value = '';
            }
            if (y.name.substring(0, 1) == 'y') {
                y.value = '';
            }
            if (y.name.substring(0, 1) == 'z') {
                y.value = '<<';
            }
        }
    }
}

function submitCartApproved(has_banfs) {
    document.orderstatus.target = "";
    document.orderstatus.artlistaction.value = 'submitcartapproved';
    document.orderstatus.submit();
}

function submitMultipleCartApproved(createoptionalbanf) {
    document.orderstatus.target = "";
    document.orderstatus.artlistaction.value = 'submitmultiplecartapproved';

    if (createoptionalbanf) {
        document.orderstatus.createoptionalbanf.value = 'Y';
    } else {
        document.orderstatus.createoptionalbanf.value = 'N';
    }

    document.orderstatus.submit();
}

function submitCartApproveWithComment(reason) {
    if (reason != null) {
        document.orderstatus.target = "";
        document.orderstatus.createoptionalbanf.value = 'N';
        document.orderstatus.approvecomment.value = reason;
        document.orderstatus.artlistaction.value = 'submitmultiplecartapproved';
        document.orderstatus.submit();
    }
}

function submitCartRevoked() {
    document.orderstatus.target = "";
    document.orderstatus.artlistaction.value = 'submitcartrevoked';
    document.orderstatus.submit();
}

function submitCartRevokedWithReason(reason) {
    if (reason) {
        document.orderstatus.target = "";
        document.orderstatus.revokereason.value = reason;
        document.orderstatus.artlistaction.value = 'submitcartrevoked';
        document.orderstatus.submit();
    } else if (reason != null) {
        alert(output['t_ablehnungsgrund_mandatory']);
    }
}

function submitCartRevokedWithReasonOptional(reason) {
    if (reason != null) {
        document.orderstatus.target = "";
        document.orderstatus.revokereason.value = reason;
        document.orderstatus.artlistaction.value = 'submitcartrevoked';
        document.orderstatus.submit();
    }
}

function submitCartRevokedByAssignments() {
    document.orderstatus.target = "";
    document.orderstatus.artlistaction.value = 'submitcartrevokedbyassignments';
    document.orderstatus.submit();
}

function submitCartRevokedByAssignmentsWithReason(reason) {
    if (reason) {
        document.orderstatus.target = "";
        document.orderstatus.revokereason.value = reason;
        document.orderstatus.artlistaction.value = 'submitcartrevokedbyassignments';
        document.orderstatus.submit();
    } else if (reason != null) {
        alert(output['t_ablehnungsgrund_mandatory']);
    }
}

function submitCartRevokedByAssignmentsWithReasonOptional(reason) {
    if (reason != null) {
        document.orderstatus.target = "";
        document.orderstatus.revokereason.value = reason;
        document.orderstatus.artlistaction.value = 'submitcartrevokedbyassignments';
        document.orderstatus.submit();
    }
}

function submitRevokeCancellationOrder() {
    document.orderstatus.target = "";
    document.orderstatus.artlistaction.value = 'submitrevokecancellationorder';
    document.orderstatus.submit();
}

function delSavedCart(cartid) {
    document.delsavedcart.target = "";
    document.delsavedcart.deletecartid.value = cartid;
    document.delsavedcart.submit();
}

function openFilterSearch(filtermode, langu, sid) {
    var c;
    c = document.quicksearch.searchcatalogpartnerid.value;
    window.open('filter_search.phtml?sid=' + sid + '&mode=' + filtermode + '&lang=' + langu + '&cid=' + c, 'cartFeatures', 'width=350,height=300,resizable=yes,scrollbars=yes,toolbar=no,location=no,directories=no,status=no,menubar=no,copyhistory=no');
}

function openSettings(langu, sid) {
    window.open('settings_new.phtml?sid=' + sid + '&lang=' + langu, 'settingswindow', 'width=1200,height=900,resizable=yes,scrollbars=yes,toolbar=no,location=no,directories=no,status=no,menubar=no,copyhistory=no');
}

function delSavedSearch(searchid) {
    document.delsavedsearch.target = "";
    document.delsavedsearch.deletesearchid.value = searchid;
    document.delsavedsearch.submit();
}

function loadSavedCart(cartid, mode, loadmultiplecarts) {
    document.loadsavedcart.target = "";
    document.loadsavedcart.loadcartmode.value = mode;
    if (loadmultiplecarts === true) {
        document.loadsavedcart.loadcartids.value = cartid;
    } else {
        document.loadsavedcart.loadcartid.value = cartid;
    }
    document.loadsavedcart.submit();
    replaceOnLoadGIF();
}

function addPendingCart(pendingcartid, cart_approval_position_add_enabled) {
    document.addpendingcart.target = "";
    document.addpendingcart.pendingcartid.value = pendingcartid;
    document.addpendingcart.deliveredamountscartid.value = pendingcartid;
    document.addpendingcart.cart_approval_position_add_enabled.value = cart_approval_position_add_enabled;
    document.addpendingcart.tues.value = 'Y';
    document.addpendingcart.submit();
}

function submitDeliveredAmountsForm(cartid, rightchangeamounts, displaymenu) {
    if (document.deliveredamounts[0].target) {
        document.deliveredamounts[0].target = "";
        document.deliveredamounts[0].displaymenu = displaymenu;
        document.deliveredamounts[0].deliveredamountscartid.value = cartid;
        if (document.deliveredamounts[0].rightchangeamounts) {
            document.deliveredamounts[0].rightchangeamounts.value = rightchangeamounts;
        }
        document.deliveredamounts[0].submit();
    } else {
        document.deliveredamounts.target = "";
        document.deliveredamounts.displaymenu = displaymenu;
        document.deliveredamounts.deliveredamountscartid.value = cartid;
        if (document.deliveredamounts.rightchangeamounts) {
            document.deliveredamounts.rightchangeamounts.value = rightchangeamounts;
        }
        document.deliveredamounts.submit();
    }
}

function deliveredAmountsCartApprove(cartid, rightchangeamounts, displaymenu) {
    document.deliveredamounts_approve.target = "";
    document.deliveredamounts_approve.deliveredamountscartid.value = cartid;
    if (document.deliveredamounts_approve.rightchangeamounts) {
        document.deliveredamounts_approve.rightchangeamounts.value = rightchangeamounts;
    }
    document.deliveredamounts_approve.submit();

}

function submitDeliveredAmountsFormOrdered(cartid, rightchangeamounts, displaymenu) {
    document.deliveredamounts_ordered.target = "";
    document.deliveredamounts_ordered.displaymenu = displaymenu;
    document.deliveredamounts_ordered.deliveredamountscartid.value = cartid;
    if (document.deliveredamounts_ordered.rightchangeamounts) {
        document.deliveredamounts_ordered.rightchangeamounts.value = rightchangeamounts;
    }
    document.deliveredamounts_ordered.submit();
}

function submitCartSapErrors(cartid, rightchangeamounts, displaymenu) {
    document.cartsaperrors.target = "";
    document.cartsaperrors.displaymenu = displaymenu;
    document.cartsaperrors.deliveredamountscartid.value = cartid;
    if (document.cartsaperrors.rightchangeamounts) {
        document.cartsaperrors.rightchangeamounts.value = rightchangeamounts;
    }
    document.cartsaperrors.submit();
}

function deliveredAmountsCart(cartid, rightchangeamounts) {
    document.deliveredamounts.target = "";
    document.deliveredamounts.deliveredamountscartid.value = cartid;
    if (document.deliveredamounts.rightchangeamounts) {
        document.deliveredamounts.rightchangeamounts.value = rightchangeamounts;
    }
    document.deliveredamounts.submit();
}

function loadSavedSearch(searchid) {
    opener.parent.document.loadsearchform.target = "";
    opener.parent.document.loadsearchform.savedsearchid.value = searchid;
    opener.parent.document.loadsearchform.submit();
    window.close();
}


function submitSaveSearch() {
    opener.parent.document.quicksearch.target = "";
    opener.parent.document.quicksearch.savename.value = document.submitsavesearch.savecartname.value;
    opener.parent.document.quicksearch.submit();
    window.close();
}

/*
 function updateDeliveredAmounts( ) {
 document.cartform.target = "";
 document.cartform.artlistaction.value = 'updatedeliveredamounts' ;
 submitFormGreyOut(document.cartform);
 }


 function updateOrderedAmounts( ) {
 document.cartform.target = "";
 document.cartform.artlistaction.value = 'updateorderedamounts' ;
 submitFormGreyOut(document.cartform);
 }
 */

function selectMenu(displaymenu) {
    document.dispmenu.target = "";
    document.dispmenu.displaymenu.value = displaymenu;
    document.dispmenu.submit();
}

function eClassNavi(key1, key2, key3) {
    document.eclassnav.target = "";
    document.eclassnav.eclasskey1.value = key1;
    document.eclassnav.eclasskey2.value = key2;
    document.eclassnav.eclasskey3.value = key3;
    document.eclassnav.submit();
}

function eClassSearch(eclassKey, eclassName, articlesearch_enabled) {
    document.eclasssearch.target = "";
    document.eclasssearch.searcheclass.value = eclassKey;
    console.log(eclassName);
    if (eclassName) {
        document.eclasssearch.searcheclassName.value = eclassName;
    }

    var displaymenu;
    if (articlesearch_enabled === 'Y') {
        displaymenu = 'articlesearch';
    } else
        displaymenu = 'quicksearch';

    document.eclasssearch.displaymenu.value = displaymenu;
    document.eclasssearch.submit();
}

function setManufacturerName(herstellernamename) {
    opener.parent.document.quicksearch.target = "";
    opener.parent.document.quicksearch.herstellername.value = herstellernamename;
    /* document.quicksearch.submit(); */
    window.close();
}

function printcatNav(catalogid, parentkey, articleviewid) {
    document.printcatnav.target = "";
    document.printcatnav.showcatid.value = catalogid;
    document.printcatnav.showcatparentkey.value = parentkey;
    document.printcatnav.showarticleviewid.value = articleviewid;
    document.printcatnav.submit();
}

function printcatSearch(catalogpartnerid, searchstring, articlesearch_enabled, catalog_id, nav_history_urls) {
    document.printcatsearch.target = "";
    document.printcatsearch.searchcatalogpartnerid.value = catalogpartnerid;
    document.printcatsearch.searchprintcat.value = searchstring;
    document.printcatsearch.searchcatalogid.value = catalog_id;
    if (articlesearch_enabled === 'Y') {
        document.printcatsearch.displaymenu.value = 'articlesearch';
    }
    document.printcatsearch.nav_history_urls.value = nav_history_urls;

    document.printcatsearch.submit();
}

function productgroupSearch(productgroup_id) {
    document.productgroupsearch.target = "";
    document.productgroupsearch.search_productgroup_id.value = productgroup_id;
    document.productgroupsearch.submit();
}

function productgroupNav(productgroup_id) {
    document.productgroupform.target = "";
    document.productgroupform.productgroup_id.value = productgroup_id;
    document.productgroupform.submit();
}

function pageResult(skipvalue, offset, elem) {
    if (!elem) {
        elem = document.quicksearch;
    }
    if (!elem) {
        elem = document.pageForm;
    }
    if (!elem) {
        elem = document.getElementById('quicksearch');
    }
    if (!elem) {
        elem = document.setfilter;
    }
    elem.target = "";
    elem.skip.value = skipvalue;
    elem.offset.value = offset;
    elem.submit();
}

/* public simply means that the variables have the suffix public */
function pageResultPublic(skipvalue, offset, elem) {
    if (!elem) {
        elem = document.quicksearch;
    }
    if (!elem) {
        elem = document.pageForm;
    }
    if (!elem) {
        elem = document.getElementById('quicksearch');
    }
    elem.target = "";
    elem.skip_public.value = skipvalue;
    elem.offset_public.value = offset;
    elem.submit();
}

/* public2 simply means that the variables have the suffix public2 */
function pageResultPublic2(skipvalue, offset, elem) {
    if (!elem) {
        elem = document.quicksearch;
    }
    if (!elem) {
        elem = document.pageForm;
    }
    if (!elem) {
        elem = document.getElementById('quicksearch');
    }
    elem.target = "";
    elem.skip_public2.value = skipvalue;
    elem.offset_public2.value = offset;
    elem.submit();
}

function articleCompare() {
    document.articlelist.target = "";
    document.articlelist.artlistaction.value = "comparearticles";
    document.articlelist.submit();
}


function addListToCart() {
    document.articlelist.target = "";
    document.articlelist.artlistaction.value = "addlisttocart";
    var artidlist = document.articlelist.artidlist.value;
    var artids = artidlist.split(";");
    var artnrs = '';
    var artamounts = '';
    var write_separator = false;
    for (var x = 0; x < artids.length; x++) {
        var artnr = document.getElementsByName('articlechkbox' + artids[x])[0];
        var amount = document.getElementsByName('articleorderamount' + artids[x])[0].value;
        if (artnr.checked) {
            if (write_separator) {
                artnrs += ";";
                artamounts += ";";
            }
            artnrs += artids[x];
            (amount == '') ? amount = 1 : amount = amount;
            artamounts += amount;
            write_separator = true;
        }
    }
    var catalogpartner = document.articlelist.searchcatalogpartnerid.value;
    var tmp_idx_catalog_ids = document.articlelist.tmp_idx_catalog_ids.value;
    var articleview_ids = document.articlelist.articleview_ids.value;
    addToCartAjax(artnrs, artamounts, catalogpartner, tmp_idx_catalog_ids, articleview_ids);
}

function addToFavorites() {
    document.articlelist.target = "";
    document.articlelist.displaymenu.value = "quicksearch";
    document.articlelist.artlistaction.value = "addtofavorites";
    document.articlelist.submit();
}

function remFromFavorites() {
    document.articlelist.target = "";
    document.articlelist.displaymenu.value = "favorites";
    document.articlelist.artlistaction.value = "remfromfavorites";
    document.articlelist.submit();
}

function addToFavoritesPartner() {
    document.articlelist.target = "";
    document.articlelist.displaymenu.value = "quicksearch";
    document.articlelist.artlistaction.value = "addtofavoritespartner";
    document.articlelist.submit();
}

function remFromFavoritesPartner() {
    document.articlelist.target = "";
    document.articlelist.displaymenu.value = "favorites";
    document.articlelist.artlistaction.value = "remfromfavoritespartner";
    document.articlelist.submit();
}

function settingsMenu(submenu) {
    document.settingsmenu.target = "";
    document.settingsmenu.displaymenu.value = 'settings';
    document.settingsmenu.submenu.value = submenu;
    document.settingsmenu.submit();
}

function uniqapppMenu(submenu) {
    document.settingsmenu.target = "";
    document.settingsmenu.displaymenu.value = 'ppp_gutscheine';
    document.settingsmenu.submenu.value = submenu;
    document.settingsmenu.submit();
}

function reportingMenu(submenu) {
    document.reportingmenu.target = "";
    document.reportingmenu.submenu.value = submenu;
    document.reportingmenu.submit();
}

function alacartMenu(submenu) {
    document.alacartmenu.target = "";
    document.alacartmenu.submenu.value = submenu;
    document.alacartmenu.submit();
}

function stageMenu(submenu) {
    document.stagemenu.target = "";
    document.stagemenu.submenu.value = submenu;
    document.stagemenu.submit();
}

function prodIdx(prodchar) {
    document.prodchar.target = "";
    document.prodchar.prodchar.value = prodchar;
    document.prodchar.submit();
}

function setChar(ch) {
    document.prodchar.target = "";
    document.prodchar.prodchar.value = ch;
    document.prodchar.submit();
}

function sortList(sortfield, sortval) {
    document.quicksearch.target = "";
    document.quicksearch.orderbyfield.value = sortfield;
    document.quicksearch.orderbyval.value = sortval;
    document.quicksearch.submit();
}

function updateCostcenter() {
    document.cartform.target = "";
    document.cartform.artlistaction.value = 'gotocheckout';
    document.cartform.displaymenu.value = 'cart';
    submitFormGreyOut(document.cartform);
}

function changeEclassFeature(feature) {
    document.eclassfeatures.target = "";
    document.eclassfeatures.submit();
}

function submitEclassFeature() {
    opener.parent.document.quicksearch.preselectedartidlist.value = 'yes';
    opener.parent.document.quicksearch.submit();
    window.close();
}

function checkCatalog(catalogid) {
    document.checkcat.target = "";
    document.checkcat.checkcatalogid.value = catalogid;
    document.checkcat.submit();
}

function setProdCatalog(catalogid) {
    document.prodcat.target = "";
    document.prodcat.setprodcatalogid.value = catalogid;
    document.prodcat.submit();
}

function articleChanges(articlechangeid) {
    document.artchange.target = "";
    document.artchange.showarticlechangeid.value = articlechangeid;
    document.artchange.submit();
}

function commitNews(newsid) {
    document.commitnews.target = "";
    document.commitnews.commitnewsid.value = newsid;
    document.commitnews.submit();
}

function newsRead(newsid) {
    document.newsread.target = "";
    document.newsread.newsreadid.value = newsid;
    document.newsread.submit();
}

function printwareDetail(artid) {
    document.printwaredetail.target = "";
    document.printwaredetail.showprintwaredetail.value = artid;
    document.printwaredetail.submit();
}

function printwarePreview(artid) {
    document.printwareaddtocart.target = "";
    document.printwareaddtocart.action = "printware_preview.phtml";
    document.printwareaddtocart.printwarepreviewartid.value = artid;
    document.printwareaddtocart.submit();
}

function printwareUsePerson() {
    document.printwareaddtocart.target = "";
    document.printwareaddtocart.action = "";
    document.printwareaddtocart.usepersondefaults.value = 'Y';
    document.printwareaddtocart.submit();
}

function printwareAddToCart(artid) {
    document.printwareaddtocart.target = "";
    document.printwareaddtocart.action = "";
    document.printwareaddtocart.displaymenu.value = 'printware';
    document.printwareaddtocart.showprintwaredetail.value = '';
    document.printwareaddtocart.printwareaddtocartartid.value = artid;
    document.printwareaddtocart.submit();
}

function delLocation(locid) {
    document.dellocation.target = "";
    document.dellocation.dellocationid.value = locid;
    document.dellocation.submit();
}

function setLocationLocked(locid, val) {
    document.locklocation.target = "";
    document.locklocation.locklocationid.value = locid;
    document.locklocation.newlockedvalue.value = val;
    document.locklocation.submit();
}

function setLocationUsersLocked(locid, val) {
    document.lockallusersprolocation.target = "";
    document.lockallusersprolocation.lockuserslocationid.value = locid;
    document.lockallusersprolocation.newuserslockedvalue.value = val;
    document.lockallusersprolocation.submit();
}

function delLocationsub(locsubid) {
    document.dellocationsub.target = "";
    document.dellocationsub.dellocationsubid.value = locsubid;
    document.dellocationsub.submit();
}

function delUser(userid) {
    document.deluser.target = "";
    document.deluser.deluserid.value = userid;
    document.deluser.submit();
}

function restoreUser(userid) {
    document.restoreuser.target = "";
    document.restoreuser.restoreuserid.value = userid;
    document.restoreuser.submit();
}

function detailsUser(userid) {
    document.detailsuser.target = "";
    document.detailsuser.detailsuserid.value = userid;
    document.detailsuser.submit();
}

function blacklistArticles() {
    document.quicksearch.target = "";
    if (document.quicksearch.artlistaction)
        document.quicksearch.artlistaction.value = '';
    document.quicksearch.blacklistartids.value = 'Y';
    document.quicksearch.submit();
}

function blacklistArticlesWithReason(reason) {
    if (reason) {
        document.quicksearch.target = "";
        if (document.quicksearch.artlistaction)
            document.quicksearch.artlistaction.value = '';
        document.quicksearch.blacklistartids.value = 'Y';
        document.quicksearch.blacklistreason.value = reason;
        document.quicksearch.submit();
    } else if (reason != null) {
        alert(output['e_bitte_geben_sie_einen_grund_fuer_die_blacklistung_ein']);
    }
}

function unblacklistArticles() {
    document.quicksearch.target = "";
    if (document.quicksearch.artlistaction)
        document.quicksearch.artlistaction.value = '';
    document.quicksearch.unblacklistartids.value = 'Y';
    document.quicksearch.submit();
}

function prefArticles() {
    document.quicksearch.target = "";
    if (document.quicksearch.artlistaction)
        document.quicksearch.artlistaction.value = '';
    document.quicksearch.prefartids.value = 'Y';
    document.quicksearch.submit();
}

function unprefArticles() {
    document.quicksearch.target = "";
    if (document.quicksearch.artlistaction)
        document.quicksearch.artlistaction.value = '';
    document.quicksearch.unprefartids.value = 'Y';
    document.quicksearch.submit();
}

function blacklistList() {
    document.articlelist.target = "";
    document.articlelist.blacklistlist.value = 'Y';
    document.articlelist.submit();
}

function blacklistListWithReason(reason) {
    if (reason) {
        document.articlelist.target = "";
        document.articlelist.blacklistlist.value = 'Y';
        document.articlelist.blacklistreason.value = reason;
        document.articlelist.submit();
    } else if (reason != null) {
        alert(output['e_bitte_geben_sie_einen_grund_fuer_die_blacklistung_ein']);
    }
}

function unblacklistList() {
    document.articlelist.target = "";
    document.articlelist.unblacklistlist.value = 'Y';
    document.articlelist.submit();
}

function addprefList() {
    document.articlelist.target = "";
    document.articlelist.addpreflist.value = 'Y';
    document.articlelist.submit();
}

function delprefList() {
    document.articlelist.target = "";
    document.articlelist.delpreflist.value = 'Y';
    document.articlelist.submit();
}

function supplierSendMail(cartid) {
    document.ordertrackfilter.target = "";
    document.ordertrackfilter.sendmail.value = 'Y';
    document.ordertrackfilter.sendmailcartid.value = cartid;
    document.ordertrackfilter.submit();
}

function set_SoapQueue_queued(mode) {
    document.soapqueueform.target = "";
    document.soapqueueform.queuemode.value = mode;
    document.soapqueueform.requeue_soapqueue.value = 'Y';
    document.soapqueueform.submit();
}

function retry_Erel() {
    document.retryerelform.retryerel.value = 'Y';
    document.retryerelform.submit();
}

function send_cart_ext() {
    document.carttoextform.cartsendtoext.value = 'Y';
    document.carttoextform.submit();
}


function retry_goodsmovement(goodsmovement_id) {
    document.goodsmovement_retry.retrygoodsmovement.value = 'Y';
    document.goodsmovement_retry.goodsmovement_id.value = goodsmovement_id;
    document.goodsmovement_retry.submit();
}

function AllMessages() {
    for (var x = 0; x < document.articlelist.elements.length; x++) {
        var y = document.articlelist.elements[x];
        if (y.name != 'ALLMSGS') {
            y.checked = document.articlelist.ALLMSGS.checked;
        }
    }
}

function setDeliverydate(datefield) {
    for (var x = 0; x < document.cartform.elements.length; x++) {
        var y = document.cartform.elements[x];
        if (y.name.substring(0, 4) == 'data') {
            y.value = datefield.value;
        }
    }
}

function setErpgroupbuyer(erpfield) {
    for (var x = 0; x < document.cartform.elements.length; x++) {
        var y = document.cartform.elements[x];
        if (y.name.substring(0, 8) == 'erp_pos_') {
            y.value = erpfield.value;
        }
    }
}

/* Image Preview */
function reloadPage(init) {
    if (init == true)
        with (navigator) {
            if ((appName == "Netscape") && (parseInt(appVersion) == 4)) {
                document.MM_pgW = innerWidth;
                document.MM_pgH = innerHeight;
                onresize = reloadPage;
            }
        }
    else if (innerWidth != document.MM_pgW || innerHeight != document.MM_pgH)
        location.reload();
}

reloadPage(true);

function findObject(n, d) {
    var p, i, x;

    if (!d)
        d = document;
    if ((p = n.indexOf("?")) > 0 && parent.frames.length) {
        d = parent.frames[n.substring(p + 1)].document;
        n = n.substring(0, p);
    }
    if (!(x = d[n]) && d.all)
        x = d.all[n];
    for (i = 0; !x && i < d.forms.length; i++)
        x = d.forms[i][n];
    for (i = 0; !x && d.layers && i < d.layers.length; i++)
        x = findObject(n, d.layers[i].document);
    if (!x && d.getElementById)
        x = d.getElementById(n);
    return x;
}

function showLayers() {
    var i, p, v, obj, args = showLayers.arguments;

    for (i = 0; i < (1); i += 3) {
        if ((obj = findObject(args[i])) != null) {
            v = args[i + 2];
            if (obj.style) {
                obj = obj.style;
                v = (v == 'show') ? 'visible' : (v == 'hide') ? 'hidden' : v;
            }
            obj.visibility = v;
            if (v == 'visible') {
                obj.top = (args[3] * 37) + 280;
            } else {
                obj.top = 0;
            }
        }
    }
}

function swapImage() {
    var i, j = 0, x, a = swapImage.arguments;
    document.MM_sr = new Array;

    for (i = 0; i < (a.length - 2); i += 3) {
        if ((x = findObject(a[i])) != null) {
            document.MM_sr[j++] = x;
            if (!x.oSrc)
                x.oSrc = x.src;
            x.src = a[i + 2];
        }
    }
}

function toggle(target) {
    obj = document.getElementById(target);
    obj.style.display = ((obj.style.display == 'none') ? '' : 'none');
}

function toggleBox(szDivID, iState) /* 1 visible, 0 hidden */ {
    if (document.layers)       /* NN4+ */
    {
        document.layers[szDivID].visibility = iState ? "show" : "hide";
    } else if (document.getElementById)      /* gecko(NN6) + IE 5+ */
    {
        var obj = document.getElementById(szDivID);
        obj.style.visibility = iState ? "visible" : "hidden";
        obj.style.display = iState ? "block" : "none";
    } else if (document.all)    /* IE 4*/
    {
        document.all[szDivID].style.visibility = iState ? "visible" : "hidden";
        document.all[szDivID].style.display = iState ? "block" : "none";
    }
}

function toggleBoxBlock(szDivID, iState) /* 1 visible, 0 hidden */ {
    if (document.layers)       /* NN4+ */
    {
        document.layers[szDivID].visibility = iState ? "show" : "hide";
    } else if (document.getElementById)      /* gecko(NN6) + IE 5+ */
    {
        var obj = document.getElementById(szDivID);
        obj.style.visibility = iState ? "visible" : "hidden";
        obj.style.display = iState ? "block" : "block";
    } else if (document.all)    /* IE 4 */
    {
        document.all[szDivID].style.visibility = iState ? "visible" : "hidden";
        document.all[szDivID].style.display = iState ? "block" : "block";
    }
}


function toggleCheckbox(szDivID) {
    iState = '1';

    if (document.layers)       /* NN4+ */
    {
        document.layers[szDivID].visibility = iState ? "show" : "hide";
    } else if (document.getElementById)      /* gecko(NN6) + IE 5+ */
    {
        var obj = document.getElementById(szDivID);
        obj.style.visibility = iState ? "visible" : "hidden";
        obj.style.display = iState ? "block" : "none";
    } else if (document.all)    /* IE 4 */
    {
        document.all[szDivID].style.visibility = iState ? "visible" : "hidden";
        document.all[szDivID].style.display = iState ? "block" : "none";
    }
}

function IsNumericString(strString)
/*  check for valid numeric strings	 */ {
    var strValidChars = "0123456789";
    var strChar;
    var blnResult = true;

    if (strString.length == 0)
        return false;

    /* test strString consists of valid characters listed above */
    for (i = 0; i < strString.length && blnResult == true; i++) {
        strChar = strString.charAt(i);
        if (strValidChars.indexOf(strChar) == -1) {
            blnResult = false;
        }
    }
    return blnResult;
}

function IsNumericStringWithComma(strString, comma)
/*  check for valid numeric strings	 */ {
    var strValidChars = "0123456789" + comma;
    var strChar;
    var blnResult = true;

    if (strString.length == 0)
        return false;

    /* test strString consists of valid characters listed above */
    for (i = 0; i < strString.length && blnResult == true; i++) {
        strChar = strString.charAt(i);
        if (strValidChars.indexOf(strChar) == -1) {
            return false;
        }
    }
    return blnResult;
}

function calculateTreeAmount() {
    var sum = document.addtocart.leaf_price_amount.value;
    sum *= 1;
    var addonidstring = document.addtocart.addon_tree_ids.value;
    var addonids = addonidstring.split(";");
    var addonid = 0;
    var obj_amount;
    var obj_price;

    for (var x = 0; x < addonids.length; x++) {
        if (addonids[x] != "") {
            obj_amount = document.getElementsByName('addon_' + addonids[x])[0];
            obj_price = document.getElementsByName('addonprice_amount_' + addonids[x])[0];
            sum = sum + (obj_amount.value * obj_price.value);
        }
    }
    sum = runde(document.addtocart.addtocartamount.value * sum, 2);

    if (isNaN(sum) || sum <= 0) {
        document.getElementsByName('sumdiv')[0].innerHTML = ((output['t_fehler_-_ueberpruefen_sie_ihre_mengeneingaben']) ? output['t_fehler_-_ueberpruefen_sie_ihre_mengeneingaben'] : 'Fehler - Überprüfen Sie Ihre Mengeneingaben');
        toggleBox('cartbutton', 0);
    } else {
        document.getElementsByName('sumdiv')[0].innerHTML = sum;
        toggleBox('cartbutton', 1);
    }
}

function StockArticlesSelected() {
    var artidlist = document.articlelist.artidlist.value;
    var artids = artidlist.split(";");
    var stockartidlist = "";

    for (var x = 0; x < artids.length; x++) {

        if (document.getElementsByName('articlechkbox' + artids[x])[0].checked) {
            if (document.getElementsByName('use_stock_table' + artids[x])[0].value == 'Y') {
                stockartidlist += artids[x] + ";"
            }
        }
    }
    return stockartidlist;
}

function checkCharCountTextarea(elem, maxsize) {
    if (elem.value.length > maxsize) {
        return true;
    }
    return false;
}


function settingsChangeDropDownState(index, thisChecked) {
    if (!document.getElementsByName("updrightAllLocationSub[" + index + "]")[0])
        return;

    var updrightAllLocationSub = false;

    if (thisChecked) {
        updrightAllLocationSub = true;
    }
    if ((document.getElementsByName("updrightlocaladmin[" + index + "]")[0] && document.getElementsByName("updrightlocaladmin[" + index + "]")[0].checked == true)
        || (document.getElementsByName("updrightbukrsadmin[" + index + "]")[0] && document.getElementsByName("updrightbukrsadmin[" + index + "]")[0].checked == true)
        || (document.getElementsByName("updrightapprove2[" + index + "]")[0] && document.getElementsByName("updrightapprove2[" + index + "]")[0].checked == true)
        || (document.getElementsByName("updrightapprove[" + index + "]")[0] && document.getElementsByName("updrightapprove[" + index + "]")[0].checked == true)
        || (document.getElementsByName("updrightorder[" + index + "]")[0] && document.getElementsByName("updrightorder[" + index + "]")[0].checked == true)) {
        updrightAllLocationSub = true;
    }

    if (updrightAllLocationSub == true) {
        document.getElementsByName("updrightAllLocationSub[" + index + "]")[0].disabled = false;
    } else {
        document.getElementsByName("updrightAllLocationSub[" + index + "]")[0].disabled = true;
    }
}

function setValueForAssignments(cartarticle_id) {

    var selectName = 'assignmenttype_' + cartarticle_id;
    var selected = $('[name=' + selectName + ']')[0];

    if (selected) {
        var selectedValue = selected.value;
    }
    var foo = [];
    $('.assignment').each(function (i, selected) {
        selected.value = selectedValue;
    });
    submitFormGreyOut(document.cartform);

}

function setValueForAll(typ, myValue, name, cartarticleId) {

    if (typ == 'costcenter') {
        var myIDs = document.getElementById('costcenter_assignment_ids').value;
    }
    if (typ == 'projectnumber') {
        var myIDs = document.getElementById('projectnumber_assignment_ids').value;
    }
    if (typ == 'pspnumber') {
        var myIDs = document.getElementById('pspnumber_assignment_ids').value;
    }
    if (typ == 'assetnumber') {
        var myIDs = document.getElementById('assetnumber_assignment_ids').value;
    }
    if (typ == 'erpgroupbuyer') {
        var myIDs = document.getElementById('erpgroupbuyer_assignment_ids').value;
    }
    if (typ == 'assignmenttype_5') {
        var myIDs = document.getElementById('assignmenttype_5_assignment_ids').value;
    }
    if (typ == 'assignmenttype_6') {
        var myIDs = document.getElementById('assignmenttype_6_assignment_ids').value;
    }
    if (typ == 'assignmenttype_7') {
        var myIDs = document.getElementById('assignmenttype_7_assignment_ids').value;
    }
    if (typ == 'assignmenttype_8') {
        var myIDs = document.getElementById('assignmenttype_8_assignment_ids').value;
    }
    if (typ == 'palfinger_x_number') {
        var myIDs = document.getElementById('costcenter_assignment_ids').value;
    }

    if (cartarticleId && (typ == 'delivery_date' || typ == 'end_date')) {
        var myIDs = document.getElementById('cartarticle_assignment_ids_' + cartarticleId).value;
    }

    if (cartarticleId && typ != 'delivery_date' && typ != 'end_date') {
        var amountIds = document.getElementById('cartarticle_assignment_ids_' + cartarticleId).value;
    }
    if (!document.getElementById('cartarticle_assignment_ids_' + cartarticleId)) {
        amountIds = '';
    }

    if (typ != 'blank') {
        const assignment_ids = myIDs.split(';');
        for (var i = 0; i < (assignment_ids.length - 1); i++) {
            if (document.getElementsByName(typ + '_' + assignment_ids[i])) {
                document.getElementsByName(typ + '_' + assignment_ids[i]).value = myValue;
            }
            if (document.getElementsByName(typ + '_' + assignment_ids[i])[0]) {
                document.getElementsByName(typ + '_' + assignment_ids[i])[0].value = myValue;
            }
            if (document.getElementsByName(typ + '_' + assignment_ids[i] + '_name')[0] && name != '') {
                document.getElementsByName(typ + '_' + assignment_ids[i] + '_name')[0].innerHTML = name;
            }
            if (document.getElementsByName(typ + '_' + assignment_ids[i] + '_name')[1] && document.getElementsByName(typ + '_' + assignment_ids[i] + '_name')[1].type == 'text' && name != '') {
                document.getElementsByName(typ + '_' + assignment_ids[i] + '_name')[1].value = name;
            }
            if (document.getElementsByName('additional_' + typ + '_' + assignment_ids[i])[0] && document.getElementsByName('additional_' + typ + '_' + assignment_ids[i])[0].disabled == false) {
                document.getElementsByName('additional_' + typ + '_' + assignment_ids[i])[0].value = myValue;
            } else if (document.getElementsByName('temp_' + typ + '_' + assignment_ids[i])[0]) {
                document.getElementsByName('temp_' + typ + '_' + assignment_ids[i])[0].value = myValue;
            } else if (document.getElementsByName('erp_charge_' + assignment_ids[i])[0]) {
                document.getElementsByName('erp_charge_' + assignment_ids[i])[0].value = myValue;
            }

            const field = document.getElementsByName(typ + '_' + assignment_ids[i]);
            if (field && field.length>0 && field[0].hasAttribute('data-live-search')) {
                console.log("data-live-search");
                $(field[0]).val(myValue);
                $('.selectpicker').selectpicker('refresh');
            }
        }
    }
    if (typ != 'delivery_date' && typ != 'end_date' && amountIds != '') {
        var amount_ids = amountIds.split(';');
        var amount_value = 0;
        for (var i = 0; i < (amount_ids.length - 1); i++) {
            if (i == 0) {
                amount_value = document.getElementsByName('assignmentamount_' + amount_ids[i])[0].value;
            }
            if (document.getElementsByName('assignmentamount_' + amount_ids[i])[0]) {
                document.getElementsByName('assignmentamount_' + amount_ids[i])[0].value = amount_value;
            }

        }
    }
}

function hideElemAndDisableChilds(elem) {
    if (elem) {
        var childs = elem.getElementsByTagName('INPUT');
        for (var i = 0; i < childs.length; i++) {
            childs[i].disabled = true;
        }
        elem.style['display'] = 'none';
        elem.style['visibility'] = 'hidden';
    }
}

function showElemAndEnableChilds(elem) {
    if (elem) {
        var childs = elem.getElementsByTagName('INPUT');
        for (var i = 0; i < childs.length; i++) {
            childs[i].disabled = false;
        }
        elem.style['display'] = '';
        elem.style['visibility'] = 'visible';
    }
}

function showElemAndShowChilds(elem) {
    if (elem) {
        $(elem).find('INPUT,SELECT').each(function () {
            showElem(this);
        });

        if (elem.style) {
            elem.style['display'] = '';
            elem.style['visibility'] = 'visible';
        }
    }
}

function jumpTo(elem_id) {
    if (elem_id != "") {
        elem = document.getElementById(elem_id);
        if (elem) {
            elem.scrollIntoView(true);
        }
    }
}

function setValueForAll2(ud_field_id, setval, elemclassname) {
    var elemlist = document.cartform.cartarticleids.value;
    elems = elemlist.split(';');

    if (!elemclassname || elemclassname == '') {
        for (var i = 0; i < elems.length; i++) {
            var elem = document.getElementsByName('ud_field_cartarticle_' + elems[i] + '_' + ud_field_id);
            var firstElem = elem[0];
            if (firstElem && firstElem != null) {
                if (firstElem.options != null) {
                    for (var j = 0; j < firstElem.options.length; j++) {
                        if (firstElem.options[j].value === setval) {
                            firstElem.selectedIndex = j;
                            break;
                        }
                    }
                    $('.selectpicker').selectpicker('refresh');
                } else if (firstElem.childElementCount < 2) {
                    firstElem.value = setval;
                    firstElem.innerHTML = setval;
                }
            }
        }
    } else {
        var elem = document.getElementsByClassName(elemclassname);
        for (var i = 0; i < elem.length; i++) {
            var currelem = elem[i];
            if (currelem && currelem != null) {
                if (currelem.options != null) {
                    for (var j = 0; j < currelem.options.length; j++) {
                        if (currelem.options[j].value === setval) {
                            currelem.selectedIndex = j;
                            break;
                        }
                    }
                    $('.selectpicker').selectpicker('refresh');
                } else if (currelem.childElementCount < 2) {
                    currelem.value = setval;
                    currelem.innerHTML = setval;
                }
            }
        }
    }
}

function setValueForAllGeneric(myids, pre_elemname, post_elemname, setval, searchtype) {
    var idlist = myids.split(';');

    for (var i = 0; i < idlist.length; i++) {
        if (searchtype == 'name') {
            var elem = document.getElementsByName(pre_elemname + idlist[i] + post_elemname);
        } else if (searchtype == 'id') {
            var elem = document.getElementById(pre_elemname + idlist[i] + post_elemname);
        }

        if (elem && elem != null) {
            mySet(elem, setval);
        }
    }
}

function hideDiv(elem) {

    if (elem != null)
        elem.innerHTML = '';

}

function destroyAllDivs(idx, selectname) {

    var idx = parseInt(idx);

    if (idx == 2) {
        hideDiv(document.getElementById('div' + selectname + '_6'));
        hideDiv(document.getElementById('div' + selectname + '_5'));
        hideDiv(document.getElementById('div' + selectname + '_4'));
        hideDiv(document.getElementById('div' + selectname + '_3'));
    }
    if (idx == 3) {
        hideDiv(document.getElementById('div' + selectname + '_6'));
        hideDiv(document.getElementById('div' + selectname + '_5'));
        hideDiv(document.getElementById('div' + selectname + '_4'));
    }
    if (idx == 4) {
        hideDiv(document.getElementById('div' + selectname + '_6'));
        hideDiv(document.getElementById('div' + selectname + '_5'));
    }
    if (idx == 5) {
        hideDiv(document.getElementById('div' + selectname + '_6'));
    }

}

var divElem = null;
var request = null;

function getApprovalWebuser(elem, sid, location_id, loc_app_sum, selected_supervisor, idx, selectname, loc_app_id) {

    request = null;
    divElem = null;

    divElem = elem;

    ajaxRequest = new createXMLHttp();
    if (ajaxRequest != null) {
        ajaxRequest.open('GET', 'ajax_function.phtml?sid=' + sid + '&location_id=' + location_id + '&loc_app_sum=' + loc_app_sum + '&selected_supervisor=' + selected_supervisor + '&index=' + idx + '&selectname=' + selectname + '&loc_app_id=' + loc_app_id, true);
        ajaxRequest.onreadystatechange = checkAjaxRequestState;
        ajaxRequest.send(null);

        request = ajaxRequest;
    }

}

function checkAjaxRequestState() {

    if (request != null) {
        if (request.readyState == 4) {
            if (request.status == 200) {
                if (divElem != null) {
                    divElem.innerHTML = request.responseText;
                }
            } else {
                alert(((output['t_fehler_bei_der_anfrage']) ? output['t_fehler_bei_der_anfrage'] : "fehler bei der anfrage"));
            }
        }
    }

}

function createXMLHttp() {
    var ret = null;
    try {
        ret = new ActiveXObject('Msxml2.XMLHTTP');
    } catch (e) {
        try {
            ret = new ActiveXObject('Microsoft.XMLHTTP');
        } catch (ee) {
            ret = null;
        }
    }
    if (!ret && typeof XMLHttpRequest != 'undefined')
        ret = new XMLHttpRequest();

    return ret;
}

function select_showArtDetail(mode, elem, parentcartarticleid, err_msg) {

    if (elem) {
        document.artdetail.parentcartarticleid.value = parentcartarticleid;

        var tmp = elem.split('|');
        var article_id = tmp[0];
        var article_type = tmp[1];
        var catalogpartner_id = tmp[2];
        var cartarticle_id = tmp[3];

        if (mode == "edit") {
            if (article_type == 'config') {
                showConfigArtDetail(article_id, 'edit', catalogpartner_id);
            } else if (article_type == 'tree') {
                showTreeArtDetail(article_id, 'edit', catalogpartner_id);
            } else {
                showArtDetail(article_id, catalogpartner_id);
            }
        } else if (mode == "view") {
            if (article_type == 'config') {
                showConfigArtDetail(cartarticle_id, 'view', catalogpartner_id);
            } else if (article_type == 'tree') {
                showTreeArtDetail(cartarticle_id, 'view', catalogpartner_id);
            } else {
                showArtDetail(article_id, catalogpartner_id);
            }
        }
    } else {
        alert(err_msg);
    }

    return false;
}

function radioButtonSelected(myelem) {
    if (myelem.length) {
        for (var i = 0; i < myelem.length; i++) {
            if (myelem[i].checked == true) {
                return true;
            }
        }
    } else if (myelem.type == 'radio') {
        if (myelem.checked == true) {
            return true;
        }
    }
    return false;
}

function radioButtonGetSelectedValue(myelem) {
    if (myelem) {
        for (var i = 0; i < myelem.length; i++) {
            if (myelem[i].checked)
                return myelem[i].value;
        }
    }
    return false;
}

function disablePage() {
    var overDiv = document.getElementById('overDiv3');

    overDiv.style.width = getAbsoluteBodyWidth();
    overDiv.style.height = getAbsoluteBodyHeight();

    overDiv.style.visibility = 'visible';
    overDiv.style.display = 'inline';
}

function enablePage() {
    var overDiv = document.getElementById('overDiv3');
    if (overDiv) {
        overDiv.style.visibility = 'hidden';
        overDiv.style.display = 'none';
    }
}

function disablePageOnReload(msg) {
    enablePage();

    var overDiv = document.getElementById('overDiv2');
    var subDivContent = document.getElementById('subDivContent2');

    if (subDivContent) {
        subDivContent.innerHTML = msg;
    }

    if (overDiv) {
        overDiv.style.width = getAbsoluteBodyWidth();
        overDiv.style.height = getAbsoluteBodyHeight() * 2;

        overDiv.style.visibility = 'visible';
        overDiv.style.display = 'inline';
    }
}

function disablePageOnDataLoad() {
    enablePage();

    var overDiv = document.getElementById('overDiv9');
    var subDivContent = document.getElementById('subDivContent9');

    if (subDivContent) {
        subDivContent.innerHTML = output['t_data_beeing_loaded'];
    }

    if (overDiv) {
        overDiv.style.width = getAbsoluteBodyWidth();
        overDiv.style.height = getAbsoluteBodyHeight() * 2;

        overDiv.style.visibility = 'visible';
        overDiv.style.display = 'inline';
    }
}

function enablePageOnDataLoad() {
    var overDiv = document.getElementById('overDiv9');
    if (overDiv) {
        overDiv.style.visibility = 'hidden';
        overDiv.style.display = 'none';
    }
}


function overDiv_popup_show(count) {
    enablePage();

    var overDiv = document.getElementById('overDiv_popup' + count);
    var overDiv2 = document.getElementById('overDiv_2popup' + count);
    var subDivContent = document.getElementById('subDivContent_popup' + count);

    overDiv.style.width = getAbsoluteBodyWidth();
    overDiv.style.height = getAbsoluteBodyHeight();

    overDiv.style.visibility = 'visible';
    overDiv.style.display = 'inline';
    overDiv2.style.visibility = 'visible';
    overDiv2.style.display = 'inline';
    //document.getElementById('subDiv_popup' + count).style.backgroundColor = document.body.style.backgroundColor;
}

function overDiv_popup_hide(count) {
    enablePage();

    var overDiv = document.getElementById('overDiv_popup' + count);
    var overDiv2 = document.getElementById('overDiv_2popup' + count);
    var subDivContent = document.getElementById('subDivContent_popup' + count);

    if (overDiv) {
        overDiv.style.width = getAbsoluteBodyWidth();
        overDiv.style.height = getAbsoluteBodyHeight();

        overDiv.style.visibility = 'hidden';
        overDiv.style.display = 'inline';
        overDiv2.style.visibility = 'hidden';
        overDiv2.style.display = 'inline';
    }
}

function enablePageOnReload() {
    var overDiv = document.getElementById('overDiv2');

    if (overDiv) {
        overDiv.style.visibility = 'hidden';
        overDiv.style.display = 'none';
    }
}

function replaceOnLoadGIF() {
    var myGIF = document.getElementById('onloadimg');
    /* article-search */
    var onloadImage = new Image(220, 19);
    onloadImage.src = mainURL + 'img/onload_img.gif';
    myGIF.src = onloadImage.src;
}

function disableAll() {
    var buttons = document.getElementsByTagName('INPUT');
    for (var i = 0; i < buttons.length; i++) {
        buttons[i].disabled = true;
    }

    var links = document.getElementsByTagName('A');
    for (var i = 0; i < links.length; i++) {
        links[i].onclick = '';
    }
}

function getAbsoluteBodyHeight() {
    var IE = (document.compatMode && document.compatMode == "CSS1Compat") ? document.documentElement : document.body || null;

    var html_scrollheight = 0;
    var body_scrollheight = 0;
    var ie_offsetheight = 0;
    var body_offsetheight = 0;
    var window_innerheight = 0;
    var window_outerheight = 0;

    var absolute_height = 0;

    if (document.html && document.html.scrollHeight) {
        html_scrollheight = document.html.scrollHeight;
    }
    if (document.body && document.body.scrollHeight) {
        body_scrollheight = document.body.scrollHeight;
    }
    if (IE && IE.offsetHeight && IE.offsetHeight > 0) {
        ie_offsetheight = IE.offsetHeight;
    }
    if (document.body && document.body.offsetHeight) {
        body_offsetheight = document.body.offsetHeight;
    }
    if (window.innerHeight) {
        window_innerheight = window.innerHeight;
    }
    if (window.outerHeight) {
        window_outerheight = window.outerHeight;
    }

    if (html_scrollheight > absolute_height)
        absolute_height = html_scrollheight;
    if (body_scrollheight > absolute_height)
        absolute_height = body_scrollheight;
    if (ie_offsetheight > absolute_height)
        absolute_height = ie_offsetheight;
    if (body_offsetheight > absolute_height)
        absolute_height = body_offsetheight;
    if (window_innerheight > absolute_height)
        absolute_height = window_innerheight;
    if (window_outerheight > absolute_height)
        absolute_height = window_outerheight;

    return absolute_height;
}

function getAbsoluteBodyWidth() {
    var IE = (document.compatMode && document.compatMode == "CSS1Compat") ? document.documentElement : document.body || null;

    var html_scrollwidth = 0;
    var body_scrollwidth = 0;
    var ie_offsetwidth = 0;
    var body_offsetwidth = 0;
    var window_innerwidth = 0;
    var window_outerwidth = 0;

    var absolute_width = 0;

    if (document.html && document.html.scrollWidth) {
    }
    if (document.body && document.body.scrollWidth) {
        body_scrollwidth = document.body.scrollWidth;
    }
    if (IE && IE.offsetWidth && IE.offsetWidth > 0) {
    }
    if (document.body && document.body.offsetWidth) {
    }
    if (window.innerWidth) {
    }
    if (window.outerWidth) {
    }

    if (html_scrollwidth > absolute_width)
        absolute_width = html_scrollwidth;
    if (body_scrollwidth > absolute_width)
        absolute_width = body_scrollwidth;
    if (ie_offsetwidth > absolute_width)
        absolute_width = ie_offsetwidth;
    if (body_offsetwidth > absolute_width)
        absolute_width = body_offsetwidth;
    if (window_innerwidth > absolute_width)
        absolute_width = window_innerwidth;
    if (window_outerwidth > absolute_width)
        absolute_width = window_outerwidth;

    return absolute_width;
}

function sortBy(myForm, sortByString) {
    var oldval = myForm.sortby.value;
    var newval1 = sortByString + ' ASC';
    var newval2 = sortByString + ' DESC';

    if (newval1 == oldval) {
        myForm.sortby.value = newval2;
    } else {
        myForm.sortby.value = newval1;
    }

    myForm.submit();
}

function sortByValue(myForm, sortByString, oldval) {
    var newval1 = sortByString + 'ASC';
    var newval2 = sortByString + 'DESC';

    if (newval1 == oldval) {
        myForm.sortby.value = newval2;
    } else {
        myForm.sortby.value = newval1;
    }

    myForm.submit();
}

function changeCursor(elem, newval) {
    elem.style.cursor = newval;
}

/* F. Permadi 2005.
 Highlights table row
 Copyright (C) F. Permadi
 This code is provided "as is" and without warranty of any kind.  Use at your own risk.
 These variables are for saving the original background colors */
var savedStates = new Array();
var savedStateCount = 0;

/* This function takes an element as a parameter and
 returns an object which contain the saved state
 of the element's background color. */
function saveBackgroundStyle(myElement) {
    saved = new Object();
    saved.element = myElement;
    saved.className = myElement.className;
    saved.backgroundColor = myElement.style["backgroundColor"];
    return saved;
}

/* This function takes an element as a parameter and
 returns an object which contain the saved state
 of the element's background color. */
function restoreBackgroundStyle(savedState) {
    savedState.element.style["backgroundColor"] = savedState.backgroundColor;
    if (savedState.className) {
        savedState.element.className = savedState.className;
    }
}

/* This function is used by highlightTableRow() to find table cells (TD) node */
function findNode(startingNode, tagName) {
    /* on Firefox, the TD node might not be the firstChild node of the TR node */
    myElement = startingNode;
    var i = 0;
    while (myElement && (!myElement.tagName || (myElement.tagName && myElement.tagName != tagName))) {
        myElement = startingNode.childNodes[i];
        i++;
    }
    if (myElement && myElement.tagName && myElement.tagName == tagName) {
        return myElement;
    }
    /* on IE, the TD node might be the firstChild node of the TR node  */
    else if (startingNode.firstChild)
        return findNode(startingNode.firstChild, tagName);
    return 0;
}

/* Highlight table row.
 newElement could be any element nested inside the table
 highlightColor is the color of the highlight */
function highlightTableRowVersionA(myElement, highlightColor) {
    var i = 0;
    /* Restore color of the previously highlighted row */
    for (i; i < savedStateCount; i++) {
        restoreBackgroundStyle(savedStates[i]);
    }
    savedStateCount = 0;

    /* If you don't want a particular row to be highlighted, set it's id to "header" */
    if (!myElement || (myElement && myElement.id && myElement.id == "header"))
        return;

    /* Highlight every cell on the row */
    if (myElement) {
        var tableRow = myElement;

        /* Save the backgroundColor style OR the style class of the row (if defined) */
        if (tableRow) {
            savedStates[savedStateCount] = saveBackgroundStyle(tableRow);
            savedStateCount++;
        }

        /* myElement is a <TR>, then find the first TD */
        var tableCell = findNode(myElement, "TD");

        var i = 0;
        /* Loop through every sibling (a sibling of a cell should be a cell)  We then highlight every siblings */
        while (tableCell) {
            /* Make sure it's actually a cell (a TD) */
            if (tableCell.tagName == "TD") {
                /* If no style has been assigned, assign it, otherwise Netscape will behave weird */
                if (!tableCell.style) {
                    tableCell.style = {};
                } else {
                    savedStates[savedStateCount] = saveBackgroundStyle(tableCell);
                    savedStateCount++;
                }
                /* Assign the highlight color */
                tableCell.style["backgroundColor"] = highlightColor;

                /* Optional: alter cursor */
                tableCell.style.cursor = 'default';
                i++;
            }
            /* Go to the next cell in the row */
            tableCell = tableCell.nextSibling;
        }
    }
}

function checkbox_checkAll(elemname, check) {
    var checkboxes = document.getElementsByName(elemname);

    for (var i = 0; i < checkboxes.length; i++) {
        checkboxes[i].checked = (check) ? true : false;
    }
}

function checkbox_checkAll_array(elemprefix, postfixarray, check) {
    var postfix_elemlist = postfixarray.split(';');

    for (var i = 0; i < postfix_elemlist.length; i++) {
        checkbox_checkAll(elemprefix + postfix_elemlist[i], check);
    }
}

function checkbox_checkAll_instring2(instring1, instring2, check) {
    var inputs = document.getElementsByTagName("input");
    for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].type == "checkbox" && inputs[i].name.indexOf(instring1) >= 0 && inputs[i].name.indexOf(instring2) >= 0) {
            inputs[i].checked = check;
        }
    }
}

function uncheck_checkbox(elemnid) {
    document.getElementById(elemnid).checked = false;
}

function view_filter_checkbox_checkAll(elementnamepart, arr, check) {

    for (var i = 0; i < arr.length; i++) {
        document.getElementById(elementnamepart + arr[i]).checked = (check) ? true : false;
    }
}

function ordertrack_checkAllPendingCarts(check) {
    var cartidlist = document.getElementsByName('cartidlist')[0].value.split(';');

    for (var i = 0; i < cartidlist.length; i++) {
        var cartchkbox = document.getElementById('cartchkbox' + cartidlist[i]);

        if (cartchkbox)
            cartchkbox.checked = (check) ? true : false;
    }

    checked_all_pending_carts = (check) ? true : false;
}

function positionreporting_reset() {
    var myform = document.positionreportform;

    myform.startdate.value = '';
    myform.enddate.value = '';
    if (myform.ordernumber_filter)
        myform.ordernumber_filter.value = '';
//	if (myform.seller_filter) myform.seller_filter.value = '';
// seller_filter and freetext_seller_filter are set to null in reporting.php
    if (myform.buyer_filter)
        myform.buyer_filter.value = '';
    if (myform.cartstatus_filter)
        myform.cartstatus_filter.value = '';
    if (myform.artnr_filter)
        myform.artnr_filter.value = '';
    if (myform.matgrp_filter)
        myform.matgrp_filter.value = '';
    if (myform.currency_filter)
        myform.currency_filter.value = '';
    if (myform.orderer_filter)
        myform.orderer_filter.value = '';
    if (myform.location_filter)
        myform.location_filter.value = '';
    if (myform.claimed_enabled)
        myform.claimed_enabled.checked = false;

    myform.newreporting.value = 'Y';
    myform.extendedFilter.value = 'N';
    myform.submit();
}

function chemiereporting_reset() {
    var myform = document.chemiereportform;

    myform.startdate.value = '';
    myform.enddate.value = '';
    if (myform.ordernumber_filter)
        myform.ordernumber_filter.value = '';
    if (myform.buyer_filter)
        myform.buyer_filter.value = '';
    if (myform.cartstatus_filter)
        myform.cartstatus_filter.value = '';

    if (myform.location_filter)
        myform.location_filter.value = '';

    myform.newreporting.value = 'Y';
    myform.submit();
}

function setExtendedFilter(showaction) {
    var myform = document.positionreportform;

    var extendedFilterButton_normal = document.getElementById('extendedFilterButton_normal');
    var extendedFilterButton_extended = document.getElementById('extendedFilterButton_extended');

    var extendedFilterHead = document.getElementById('extendedFilterHead');
    var extendedFilterValues = document.getElementById('extendedFilterValues');

    var checkboxFilterHead = document.getElementById('checkboxFilterHead');
    var checkboxFilterValues = document.getElementById('checkboxFilterValues');

    var freetextFilterHead = document.getElementById('freetextFilterHead');
    var freetextFilterValues = document.getElementById('freetextFilterValues');

    /* set visible */
    if (showaction) {
        myform.extendedFilter.value = 'Y';

        hideElem(extendedFilterButton_extended);
        showElem(extendedFilterButton_normal);
        showElem(extendedFilterHead);
        showElem(extendedFilterValues);
        showElem(checkboxFilterHead);
        showElem(checkboxFilterValues);
        showElem(freetextFilterHead);
        showElem(freetextFilterValues);
    }
    /* set invisible */
    else {
        myform.extendedFilter.value = 'N';

        showElem(extendedFilterButton_extended);
        hideElem(extendedFilterButton_normal);
        hideElem(extendedFilterHead);
        hideElem(extendedFilterValues);
        hideElem(checkboxFilterHead);
        hideElem(checkboxFilterValues);
        hideElem(freetextFilterHead);
        hideElem(freetextFilterValues);
    }
}

function freetext_mepicode_reload(level, myform) {

    myform.mepicode_reloadedlevel.value = level;

    myform.submit();
}

function hideElem(elem) {
    if (elem) {
        elem.style['display'] = 'none';
        elem.style['visibility'] = 'hidden';
    }
}

function showElem(elem) {
    if (elem) {
        elem.style['display'] = '';
        elem.style['visibility'] = 'visible';
    }
}

function showElemsByName(elemName) {
    $("[name^=" + elemName + "]").each(function () {
            if (this) {
                showElem(this);
            }
        }
    );
}

function hideElemsByName(elemName) {
    $("[name^=" + elemName + "]").each(function () {
            if (this) {
                hideElem(this);
            }
        }
    );
}

function enableElem(elem) {
    if (elem)
        elem.disabled = false;
}

function disableElem(elem) {
    if (elem)
        elem.disabled = true;
}

function mySet(elem, val) {
    if (elem) {
        if (typeof elem == 'object' && elem.length) {
            for (var i = 0; i < elem.length; i++) {
                if (elem.item(i)) {
                    mySet(elem.item(i), val);
                } else {
                    mySet(elem, val);
                }
            }
        } else if ((elem.tagName == "SPAN" || elem.tagName == "DIV") && elem.innerHTML) {
            elem.innerHTML = val;
        } else {
            elem.value = val;
        }
    }
}

function getKeyCode(event) {
    event = event || window.event;
    return event.keyCode;
}

function in_array(val, arr) {
    if (val && arr) {
        for (var elem in arr) {
            if (arr[elem] == val)
                return true;
        }
    }

    return false;
}

function setRed(elem) {
    if (elem) {
        elem.style.backgroundColor = '#FF0000';
    }
}

function checkApprovalSettings() {
    myform = document.editForm;

    for (var i = 0; i < myform.length; i++) {
        var elem = myform[i];

        elem.style.backgroundColor = '';
    }

    var error = false;
    if (myform.ed_maxamount_source && myform.ed_maxamount && myform.ed_maxamount_source.value == 'location_approval' && isNaN(parseFloat(myform.ed_maxamount.value))) { //prüfung ob zahl
        setRed(myform.ed_maxamount);
        error = true;
    }

    if (myform.ed_text && myform.ed_text.value == '') {
        setRed(myform.ed_text);
        error = true;
    }

    return !error;
}

function ordertrack_deleteOrder(deletereason) {
    if (deletereason != null) {
        document.deleteorderform.deletereason.value = deletereason;
        document.deleteorderform.submit();
    }
}

function ordertrack_deleteorder_fromDB() {
    document.deleteorderformDB.submit();
}

function ordertrack_cancelOrder(cancelreason) {
    if (cancelreason != null) {
        document.cancelorderform.cancelreason.value = cancelreason;
        document.cancelorderform.submit();
    }
}

function ordertrack_recordOrder(recordreason) {
    if (recordreason != null) {
        document.recordorderform.recordreason.value = recordreason;
        document.recordorderform.submit();
    }
}

function ordertrack_setNoERPOrder(comment) {
    if (comment != null) {
        document.noERPorderform.noERPreason.value = comment;
        document.noERPorderform.submit();
    }
}

function toggleInfoDiv(id) {
    var elem = document.getElementById('info_div_id_' + id);
    if (elem.style.visibility == 'hidden') {
        elem.style.visibility = 'visible';
    } else {
        elem.style.visibility = 'hidden';
    }
}

function checkYenComma(price_amount, price_currency, message) {
    var value = price_amount.value;
    var len = value.length;
    var pos = 0;

    if (price_currency.value == 'JPY') {
        pos = value.indexOf(',');
        if (pos < 0) {
            pos = value.indexOf('.');
        }
        if (pos >= 0) {
            price_amount.value = value.substring(0, pos);
            alert(message);
        }
    }
}

function getAjax(file, element, params) {
    $('#' + element).load(file + '?' + params);
}

/* BA */
function orderassistant_setLocSubCount(elem, location_id) {
    var changeval = 0;
    if (elem.checked)
        changeval = 1;
    else
        changeval = -1;

    var hiddencount = document.getElementById('loc_sub_count' + location_id);
    var showncount = document.getElementById('loc_sub_count_show' + location_id);

    var old_ = parseInt(hiddencount.value);
    var new_ = old_ + changeval;

    hiddencount.value = new_;
    showncount.innerHTML = new_;

    var hiddencount_total = document.submitmultiplycart.loc_sub_count_total;
    var showncount_total = document.getElementById('loc_sub_count_total_show');

    old_ = parseInt(hiddencount_total.value);
    new_ = old_ + changeval;

    hiddencount_total.value = new_;
    showncount_total.innerHTML = new_;

    return false;
}

/* MA */

function convertDateFromInput2Unix(date) {
    var date_array = date.split('.');
    var date_js = date_array[1] + '/' + date_array[0] + '/' + date_array[2];
    var ts = Math.round(new Date(date_js).getTime() / 1000);
    return ts;
}

function addDaysToSecondDateField(org_date, days, set1, set2) {
    new_date = convertDateFromInput2Unix(org_date);
    new_date += (days * 86400) + 43200;
    date = new Date(new_date * 1000);
    day = date.getDate();
    month = (date.getMonth() + 1);
    date_days_added = '';
    if (day < 10) {
        date_days_added = '0';
    }
    date_days_added += day + '.';
    if (month < 10) {
        date_days_added += '0';
    }
    date_days_added += month + '.' + date.getFullYear();
    set1.value = date_days_added;
    set2.innerHTML = date_days_added;
}

var tooltip = function () {
    var id = 'tt';
    var top = 3;
    var left = 3;
    var maxw = 300;
    var speed = 10;
    var timer = 20;
    var endalpha = 95;
    var alpha = 0;
    var tt, t, c, b, h;
    var ie = document.all ? true : false;
    return {
        show: function (v, w) {
            if (tt == null) {
                tt = document.createElement('div');
                tt.setAttribute('id', id);
                t = document.createElement('div');
                t.setAttribute('id', id + 'top');
                c = document.createElement('div');
                c.setAttribute('id', id + 'cont');
                b = document.createElement('div');
                b.setAttribute('id', id + 'bot');
                tt.appendChild(t);
                tt.appendChild(c);
                tt.appendChild(b);
                document.body.appendChild(tt);
                tt.style.opacity = 0;
                tt.style.filter = 'alpha(opacity=0)';
                if (navigator.appName == 'Microsoft Internet Explorer' && navigator.appVersion.substring(0, 1) == "3") {
                    // do not move the tool tip.
                } else {
                    document.onmousemove = this.pos;
                }
            }
            tt.style.display = 'block';
            c.innerHTML = v;
            tt.style.width = w ? w + 'px' : 'auto';
            if (!w && ie) {
                t.style.display = 'none';
                b.style.display = 'none';
                tt.style.width = tt.offsetWidth;
                t.style.display = 'block';
                b.style.display = 'block';
            }
            if (tt.offsetWidth > maxw) {
                tt.style.width = maxw + 'px'
            }
            h = parseInt(tt.offsetHeight) + top;
            clearInterval(tt.timer);
            tt.timer = setInterval(function () {
                tooltip.fade(1)
            }, timer);
        },
        pos: function (e) {
            var u = ie ? event.clientY + document.documentElement.scrollTop : e.pageY;
            var l = ie ? event.clientX + document.documentElement.scrollLeft : e.pageX;
            tt.style.top = (u - h) + 'px';
            tt.style.left = (l + left) + 'px';
        },
        fade: function (d) {
            var a = alpha;
            if ((a != endalpha && d == 1) || (a != 0 && d == -1)) {
                var i = speed;
                if (endalpha - a < speed && d == 1) {
                    i = endalpha - a;
                } else if (alpha < speed && d == -1) {
                    i = a;
                }
                alpha = a + (i * d);
                tt.style.opacity = alpha * .01;
                tt.style.filter = 'alpha(opacity=' + alpha + ')';
            } else {
                clearInterval(tt.timer);
                if (d == -1) {
                    tt.style.display = 'none'
                }
            }
        },
        hide: function () {
            clearInterval(tt.timer);
            tt.timer = setInterval(function () {
                tooltip.fade(-1)
            }, timer);
        }
    };
}();

function setVal4AllEqualFormElems(elemname, val) {
    setValueForAllGeneric(elemname + ';', '', '', val, 'name');
}

function addOutputValue(index, value) {
    output[index] = value;
}

function addLuserValue(index, value) {
    l_user[index] = value;
}

function getTextFromSpan(span_id) {
    var text = span_id.innerHTML;
    return text;
}

function setValueForAllGeneric2(myids, counter, pre_elemname, post_elemname, setval, inputtype) {
    var idlist = myids.split(';');
    for (var i = 0; i < idlist.length; i++) {
        for (var j = counter; j <= counter; j++) {
            if (inputtype == 'input') {
                var elem = document.getElementsByName(pre_elemname + idlist[i] + '_' + j);
                if (elem && elem != null) {
                    mySet(elem, setval);
                }
            }
            if (inputtype == 'span') {
                var elem = document.getElementById(pre_elemname + idlist[i] + '_' + j + post_elemname);
                if (elem && elem != null) {
                    elem.innerHTML = setval;
                }
            }
            if (inputtype == 'checkbox') {
                checkbox_checkAll(pre_elemname + idlist[i] + '_' + j, setval);
            }
            if (inputtype == 'input_by_id') {
                var elem = document.getElementById(pre_elemname + idlist[i] + '_' + j);
                if (elem && elem != null) {
                    mySet(elem, setval);
                }
            }
        }
    }
}

function setValueForAllGeneric3(myids, pre_elemname, post_elemname, setval, inputtype) {
    var idlist = myids.split(';');
    for (var i = 0; i < idlist.length; i++) {
        if (inputtype == 'input') {
            var elem = document.getElementsByName(pre_elemname + idlist[i]);
            if (elem && elem != null) {
                mySet(elem, setval);
            }
        }
        if (inputtype == 'span') {
            var elem = document.getElementById(pre_elemname + idlist[i] + post_elemname);
            if (elem && elem != null) {
                elem.innerHTML = setval;
            }
        }
        if (inputtype == 'checkbox') {
            checkbox_checkAll(pre_elemname + idlist[i], setval);
        }
        if (inputtype == 'input_by_id') {
            var elem = document.getElementById(pre_elemname + idlist[i]);
            if (elem && elem != null) {
                mySet(elem, setval);
            }
        }
    }
}

function setInputfieldDisable(element_id, element_null_id) {
    var elem = document.getElementById(element_id);
    if (!elem)
        elem = document.getElementById(element_id + '_supplier_aid');
    if (element_null_id) {
        var elem_checkbox_null = document.getElementById(element_null_id);
    } else {
        var elem_checkbox_null = document.getElementById(element_id + '_null');
    }

    if (elem && elem_checkbox_null) {
        if (elem_checkbox_null.checked == false) {
            elem.disabled = true;
            if (elem.selectedIndex) {
                elem.selectedIndex = '';
            } else if (elem.value) {
                elem.value = '';
            }

            //  if <select> element
            if (elem.tagName.toLowerCase() === 'select') {
                var button = document.querySelector('button[data-id="' + element_id + '"]');
                if (button) {
                    button.classList.add('disabled');
                }
            }
        } else {
            elem.disabled = false;

            //  if <select> element
            if (elem.tagName.toLowerCase() === 'select') {
                var button = document.querySelector('button[data-id="' + element_id + '"]');
                if (button) {
                    button.classList.remove('disabled');
                }
            }
        }
    }
}

function setInputfieldDisableTime(element_id) {
    setInputfieldDisable(element_id + '_hour', element_id + '_null');
    setInputfieldDisable(element_id + '_minute', element_id + '_null');
    setInputfieldDisable(element_id);
}

function splitCartByFreetextSeller() {
    document.orderstatus.target = "";
    document.orderstatus.artlistaction.value = 'splitcartbyfreetextseller';
    document.orderstatus.submit();
}

function oneCheckboxSelected(element_ids) {
    var idlist = element_ids.split(';');
    for (var i = 0; i < idlist.length; i++) {
        var elem = document.getElementById(idlist[i]);
        if (elem.checked == true) {
            return true;
        }
    }

    return false;
}

function allCheckedPositionsHaveClusterId(element_ids) {
    var idlist = element_ids.split(';');
    for (var i = 0; i < idlist.length; i++) {
        var elem = document.getElementById('cluster_hidden_' + idlist[i]);
        if (document.getElementById(idlist[i]).checked == true && !elem.value) {
            return false;
        }
    }
    return true;
}

function ordertrackdetail_getSelectedCartarticles() {
    var cartarticleids = document.cartform.cartarticleids.value;
    var cartarticle_array = cartarticleids.split(';');

    var selected_cartarticles = '';

    for (var i = 0; i < cartarticle_array.length; i++) {
        var tmp = document.getElementsByName('checkcartarticle' + cartarticle_array[i])[0];

        if (tmp && tmp.checked) {
            selected_cartarticles = selected_cartarticles + cartarticle_array[i] + ',';
        }
    }

    if (selected_cartarticles != '') {
        return selected_cartarticles.substring(0, selected_cartarticles.length - 1);
    }

    return selected_cartarticles;
}

function setNetValPrice(prefix, percent_enabled, absolute_enabled, comma) {
    var netto_value = null;
    var new_price_amount = document.getElementById(prefix + '_price_amount').value;
    var percent = '';
    if (percent_enabled == 'Y')
        percent = document.getElementById(prefix + '_musslieferant_input').value;
    var absolute = '';
    if (absolute_enabled == 'Y')
        absolute = document.getElementById(prefix + '_discount_absolute').value;
    var currency = document.getElementById(prefix + '_price_currency').value;

    if ((IsNumericStringWithComma(new_price_amount, comma) === false && new_price_amount != null && new_price_amount != '') || (IsNumericStringWithComma(percent, comma) === false && percent != null && percent != '') || (IsNumericStringWithComma(absolute, comma) === false && absolute != null && absolute != '') || (formatFloatValue(new_price_amount, comma) - formatFloatValue(absolute, comma)) < 0) {
        if (IsNumericStringWithComma(new_price_amount, comma) === false && new_price_amount != null && new_price_amount != '')
            netto_value = output['t_nettopreis'] + ': ' + output['e_preis_ist_keine_zahl'];
        else if (IsNumericStringWithComma(percent, comma) === false && percent != null && percent != '')
            netto_value = output['t_nettopreis'] + ': ' + output['t_ungueltiger_rabatt'];
        else if (IsNumericStringWithComma(absolute, comma) === false && absolute != null && absolute != '')
            netto_value = output['t_nettopreis'] + ': ' + output['e_ungueltiger_rabatt_absolut'];
        else if ((formatFloatValue(new_price_amount, comma) - formatFloatValue(absolute, comma)) < 0)
            netto_value = output['t_nettopreis'] + ': ' + output['e_absoluter_rabatt_derf_nicht_weniger_als_null_ergeben'];
    } else {
        new_price_amount = formatFloatValue(new_price_amount, comma);
        if (percent != '') {
            percent = formatFloatValue(percent, comma);
            netto_value = (new_price_amount - (new_price_amount * (percent / 100)));
        }
        if (absolute != '' && absolute != 0) {
            absolute = formatFloatValue(absolute, comma);
            netto_value = (new_price_amount - absolute);

        }
        if (netto_value == null) {
            netto_value = new_price_amount;
        }
        netto_value = makePriceShowFreetextNetPrice(netto_value, currency, comma);
    }
    mySet(document.getElementById(prefix + '_netto_price'), netto_value);
}

function setNetValPercent(prefix, absolute_enabled, comma) {
    var new_price_amount = document.getElementById(prefix + '_price_amount').value;
    var new_percent_discount = document.getElementById(prefix + '_musslieferant_input').value;
    var new_price_currency = document.getElementById(prefix + '_price_currency').value;
    var netto_value = null;

    if ((IsNumericStringWithComma(new_price_amount, comma) === false && new_price_amount != null && new_price_amount != '') || (IsNumericStringWithComma(new_percent_discount, comma) === false && new_percent_discount != null && new_percent_discount != '')) {
        if (IsNumericStringWithComma(new_price_amount, comma) === false && new_price_amount != null && new_price_amount != '')
            netto_value = output['t_nettopreis'] + ': ' + output['e_preis_ist_keine_zahl'];
        else if (IsNumericStringWithComma(new_percent_discount, comma) === false && new_percent_discount != null && new_percent_discount != '')
            netto_value = output['t_nettopreis'] + ': ' + output['t_ungueltiger_rabatt'];
    } else {
        new_percent_discount = formatFloatValue(new_percent_discount, comma);
        new_price_amount = formatFloatValue(new_price_amount, comma);

        netto_value = new_price_amount - (new_price_amount * (new_percent_discount / 100));

        netto_value = makePriceShowFreetextNetPrice(netto_value, new_price_currency, comma);
    }

    mySet(document.getElementById(prefix + '_netto_price'), netto_value);
    if (absolute_enabled == 'Y')
        mySet(document.getElementById(prefix + '_discount_absolute'), 0);
}

function setNetValAbsolute(prefix, percent_enabled, comma) {
    var new_price_amount = document.getElementById(prefix + '_price_amount').value;
    var new_price_currency = document.getElementById(prefix + '_price_currency').value;
    var new_absolute_discount = document.getElementById(prefix + '_discount_absolute').value;
    var netto_value = null;

    if ((IsNumericStringWithComma(new_price_amount, comma) === false && new_price_amount != null && new_price_amount != '') || (IsNumericStringWithComma(new_absolute_discount, comma) === false && new_absolute_discount != null && new_absolute_discount != '') || (formatFloatValue(new_price_amount, comma) - formatFloatValue(new_absolute_discount, comma)) < 0) {
        if (IsNumericStringWithComma(new_price_amount, comma) === false && new_price_amount != null && new_price_amount != '')
            netto_value = output['t_nettopreis'] + ': ' + output['e_preis_ist_keine_zahl'];
        else if (IsNumericStringWithComma(new_absolute_discount, comma) === false && new_absolute_discount != null && new_absolute_discount != '')
            netto_value = output['t_nettopreis'] + ': ' + output['e_ungueltiger_rabatt_absolut'];
        else if ((formatFloatValue(new_price_amount, comma) - formatFloatValue(new_absolute_discount, comma)) < 0)
            netto_value = output['t_nettopreis'] + ': ' + output['e_absoluter_rabatt_derf_nicht_weniger_als_null_ergeben'];
    } else {
        new_price_amount = formatFloatValue(new_price_amount, comma);
        new_absolute_discount = formatFloatValue(new_absolute_discount, comma);
        netto_value = new_price_amount - new_absolute_discount;
        netto_value = makePriceShowFreetextNetPrice(netto_value, new_price_currency, comma);
    }

    mySet(document.getElementById(prefix + '_netto_price'), netto_value);
    if (percent_enabled == 'Y')
        mySet(document.getElementById(prefix + '_musslieferant_input'), 0);
}

function makePriceShowFreetextNetPrice(price, currency, comma) {
    var netto_value = null;
    netto_value = (Math.round(price * 100) / 100).toFixed(2);
    netto_value = netto_value.replace(/\./, comma);
    netto_value = netto_value + ' ' + currency;
    netto_value = ' (' + output['t_nettopreis'] + ': ' + netto_value + ')';

    return netto_value;
}

function formatFloatValue(val, comma) {

    var replace_val = '';

    if (comma == ',') {
        val = val.replace(/\./, "");
        val = val.replace(/,/, '.');
    } else {
        val = val.replace(/,/, "");
    }

    return val;
}

function str_replace(search, replace, subject, count) {
    // Replaces all occurrences of search in haystack with replace  
    // 
    // version: 1109.2015
    // discuss at: http://phpjs.org/functions/str_replace
    // +   original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +   improved by: Gabriel Paderni
    // +   improved by: Philip Peterson
    // +   improved by: Simon Willison (http://simonwillison.net)
    // +	revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    // +   bugfixed by: Anton Ongson
    // +	  input by: Onno Marsman
    // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +	tweaked by: Onno Marsman
    // +	  input by: Brett Zamir (http://brett-zamir.me)
    // +   bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +   input by: Oleg Eremeev
    // +   improved by: Brett Zamir (http://brett-zamir.me)
    // +   bugfixed by: Oleg Eremeev
    // %		  note 1: The count parameter must be passed as a string in order
    // %		  note 1:  to find a global variable in which the result will be given
    // *	 example 1: str_replace(' ', '.', 'Kevin van Zonneveld');
    // *	 returns 1: 'Kevin.van.Zonneveld'
    // *	 example 2: str_replace(['{name}', 'l'], ['hello', 'm'], '{name}, lars');
    // *	 returns 2: 'hemmo, mars'
    var i = 0,
        j = 0,
        temp = '',
        repl = '',
        sl = 0,
        fl = 0,
        f = [].concat(search),
        r = [].concat(replace),
        s = subject,
        ra = Object.prototype.toString.call(r) === '[object Array]',
        sa = Object.prototype.toString.call(s) === '[object Array]';
    s = [].concat(s);
    if (count) {
        this.window[count] = 0;
    }

    for (i = 0, sl = s.length; i < sl; i++) {
        if (s[i] === '') {
            continue;
        }
        for (j = 0, fl = f.length; j < fl; j++) {
            temp = s[i] + '';
            repl = ra ? (r[j] !== undefined ? r[j] : '') : r[0];
            s[i] = (temp).split(f[j]).join(repl);
            if (count && s[i] !== temp) {
                this.window[count] += (temp.length - s[i].length) / f[j].length;
            }
        }
    }
    return sa ? s : s[0];
}


/*
 // can not copy the code in a correct way (smiley in it...
 // http://www.sencha.com/forum/showthread.php?5499-Other-currency-formats-other-than-usMoney
 Ext.util.Format.CurrencyFactory = function(c, d, t, s) {
 return function(n) {
 var m = (c = Math.abs(c) + 1 ? c : 2, d = d || ",", t = t || ".",/(d+)(?.'\.d+)|)/.exec(n + "")), x = m[1].length > 3 ? m[1].length % 3 : 0;
 return ((x ? m[1].substr(0, x) + t : "") + m[1].substr(x).replace(/(d{3})(?=d)/g,"$1" + t) + (c ? d + (+m[2] || 0).toFixed(c).substr(2) : ""))+" "+s;
 }
 }
 var euroFormatter = Ext.util.Format.CurrencyFactory(2, ",", ".", "€");
 var dollarFormatter = Ext.util.Format.CurrencyFactory(2, ",", ".", "$");
 var yenFormatter = Ext.util.Format.CurrencyFactory(2, ",", ".", "YEN");

 */

//plug German currency renderer into formatter
var currencyFormatter = function (value, sign) {
    if (!sign) {
        sign = 'EUR';
    }
    value = (Math.round((value - 0) * 100)) / 100;
    value = (value == Math.floor(value)) ? value + ".00" : ((value * 10 == Math.floor(value * 10)) ? value + "0" : value);
    return (sign + ' ' + value).replace(/\./, price_edit_decimal_separator);
};


function drawIcon(type, js_action, alternative_tooltip, url, text, element_id, align, target) {
    if (!url) {
        url = "javascript:void(0)";
    }
    var img_src = "";
    var only_img = "N";
    var only_link = "N";

    switch (type) {
        case 'addarticletocart': {
            if (l_user['release_3x_enabled'] == 'Y') {
                img_src = "icons/addarticletocart.png";
            } else {
                img_src = cartimg;
            }
            if (!alternative_tooltip && l_user["release_3x_enabled"] == "Y") {
                alternative_tooltip = output["tp_addarticletocart"];
            }
            break;
        }
        case 'addarticletocart_pref': {
            if (l_user['release_3x_enabled'] == 'Y') {
                img_src = "icons/addarticletocart_pref.png";
            } else {
                img_src = cartimg_pref;
            }
            if (!alternative_tooltip && l_user["release_3x_enabled"] == "Y") {
                alternative_tooltip = output["tp_addarticletocart_pref"];
            }
            break;
        }
        case 'blacklisted': {
            if (l_user['release_3x_enabled'] == 'Y') {
                img_src = "icons/blacklisted.png";
            } else {
                img_src = "gfx/blacklisted.gif";
            }
            if (!alternative_tooltip && l_user["release_3x_enabled"] == "Y") {
                alternative_tooltip = output["tp_blacklisted"];
            }
            break;
        }
        case 'done': {
            only_img = 'Y';
            if (l_user['release_3x_enabled'] == 'Y') {
                img_src = "icons/done.png";
            } else {
                img_src = "gfx/done1.gif";
            }
            if (!alternative_tooltip && l_user["release_3x_enabled"] == "Y") {
                alternative_tooltip = output["tp_blacklisted"];
            }
            break;
        }
        case 'download_pdf': {
            if (l_user['release_3x_enabled'] == 'Y') {
                img_src = "icons/download_pdf";
            } else {
                img_src = "gfx/pdf_small.gif";
            }
            if (!alternative_tooltip && l_user["release_3x_enabled"] == "Y") {
                alternative_tooltip = output["tp_download_pdf"];
            }
            break;
        }
    }
    return '<img src="' + img_src + '" onclick="' + js_action + '" border="0">';
}

function checkUncheckArticlesCheckBoxes(chkchecked) {
    var chkArray = new Array();
    chkArray = document.getElementsByTagName('input');
    for (var i = 0; i < chkArray.length; i++) {
        if (chkArray[i].type == 'checkbox' && chkArray[i].getAttribute("name").search(/^articlechkbox/) != -1) {
            chkArray[i].checked = chkchecked;
        }
    }
}

function addCartSumAjax(index) {
    if (!index) {
        index = 0;
    }
    if (addCartSumArray[index]) {
        if (!cartSumByID_EUR[addCartSumArray[index]['div_name_without_cart_id']]) {
            cartSumByID_EUR[addCartSumArray[index]['div_name_without_cart_id']] = 0;
            cartSumByID_EUR_tax[addCartSumArray[index]['div_name_without_cart_id']] = 0;
        }
        var element_id = addCartSumArray[index]['div_name_without_cart_id'] + addCartSumArray[index]['cart_id'];
        $("#" + element_id).html('<img src="img/ajaxLoaderSmall.gif">');
        $("#" + element_id + '_tax').html('<img src="img/ajaxLoaderSmall.gif">');
        $("#" + element_id + '_gross').html('<img src="img/ajaxLoaderSmall.gif">');
        var page = "ajax-backend/getCartSum.php";
        var element_id = element_id;
        var dataString = 'sid=' + sid + '&index=' + addCartSumArray[index]['div_name_without_cart_id'] + '&json=' + JSON.stringify(addCartSumArray[index]);
        ajaxHandler = $.ajax({
            url: page,
            type: "post",
            data: dataString,
            context: document.getElementById(element_id),
            success: function (content) {
                $("#" + element_id).html(content);
                runAjax("ajax-backend/formatPrice_show.php?sid=" + sid + "&price=" + cartSumByID_EUR[addCartSumArray[index]['div_name_without_cart_id']], addCartSumArray[index]['div_name_without_cart_id'] + 'sum', '', false);
                runAjax("ajax-backend/formatPrice_show.php?sid=" + sid + "&price=" + cartSumByID_EUR_tax[addCartSumArray[index]['div_name_without_cart_id']], addCartSumArray[index]['div_name_without_cart_id'] + 'sum_tax', '', false);
                runAjax("ajax-backend/formatPrice_show.php?sid=" + sid + "&price=" + (cartSumByID_EUR[addCartSumArray[index]['div_name_without_cart_id']] + cartSumByID_EUR_tax[addCartSumArray[index]['div_name_without_cart_id']]), addCartSumArray[index]['div_name_without_cart_id'] + 'sum_gross', '', false);
                addCartSumAjax(index + 1);
            },
            statusCode: {
                404: function () {
                    alert("Error on ajax: Not found: '" + page + "'");
                }
            }
        });


    }
}


function configarticleGeneratePdf(sid, cartarticle_id) {

    disablePageOnReload(output['t_pdf_wird_generiert']);
    replaceOnLoadGIF();

    var element_id = "configarticles_pdf_span_" + cartarticle_id;

    var data;

    $.ajax(
        {
            url: "proservice_configarticle_pdf_generator.php?sid=" + sid + "&ca_id=" + cartarticle_id,
            dataType: 'json',
            data: data,
            async: true,
            cache: false,
            success: function (data) {

                var json_data = eval(data);


                elem = document.getElementById(element_id);

                elem.innerHTML = '<a href="cartarticle_getfile.phtml?sid=' + sid + '&caid=' + json_data.caa_id + '">' + drawIcon('download_pdf', '') + '</a>';

                enablePageOnReload();

                submitFormGreyOut(document.cartform);
            }
        }).error(function () {
        alert(output['e_pdf_generieren_fehlgeschlagen']);
    })
}


/**
 *
 * encapsulates logic-functions
 *
 * @ Author: olbe, 24.04.2015
 *
 */
var oJSFunc =
    {
        /**
         *
         * @param {type} a
         * @param {type} b
         * @returns {Boolean: true/false}
         *
         * emulates logic xor-function
         *
         */
        jsXOR: function (a, b) {
            return (a || b) && !(a && b);
        },
        lPad: function (str, width, c) {
            c = c || '0';
            str = str + '';

            return ((str.length >= width) ? str : new Array(width - str.length + 1).join(c) + str);
        },
        getObj: function (sSearchedKey, oObject) {
            for (var key in oObject) {
                if (key === sSearchedKey) {
                    return oObject[key];
                }
            }

            return null;
        },
        getObjStr: function (oObject) {
            var sOut = '';
            for (var key in oObject) {
                sOut += key + ': ' + oObject[key] + '\n';
            }

            return sOut;
        }
    };


function getElementsByClassNameTraditional(findClass, parent) {

    parent = parent || document;
    var elements = parent.getElementsByTagName('*');
    var matching = [];

    for (var i = 0, elementsLength = elements.length; i < elementsLength; i++) {

        if ((' ' + elements[i].className + ' ').indexOf(findClass) > -1) {
            matching.push(elements[i]);
        }

    }

    return matching;

}

function cloneSimpleObject(obj) {
    if (null == obj || "object" != typeof obj)
        return obj;
    var copy = obj.constructor();
    for (var attr in obj) {
        if (obj.hasOwnProperty(attr))
            copy[attr] = obj[attr];
    }
    return copy;
}

/***********************/
/***** confirm.js ******/
/***********************/

//Box anzeigen
function showConfirm(id, publicCartAutoDelete, simulate, loadmultiplecarts, cart_load_private_cart_default_mode) {
    var confirmTitle = "<p align='center'><b>" + output['t_sicherheitsabfrage'] + "</b></p>";
    if (loadmultiplecarts === true) {
        var confirmText = "<p align='center'>" + output['t_wollen_sie_den_warenkorb_ueberschreiben_hinzufuegen_multiple'] + "?</p>";
        var confirmText2 = "<p><center>" + output['t_hinweis_warenkorb_wird_geloescht_multiple'] + "</center></p>";
    } else {
        var confirmText = "<p align='center'>" + output['t_wollen_sie_den_warenkorb_ueberschreiben_hinzufuegen'] + "?</p>";
        var confirmText2 = "<p><center>" + output['t_hinweis_warenkorb_wird_geloescht'] + "</center></p>";
    }

    if (simulate) {
        confirmText = "<p align='center'>" + (l_user['simulated_loadcart_mode'] == 'original' ? output['t_wollen_sie_ueberschreiben_oder_hinzufuegen'] : output['t_wollen_sie_ueberschreiben_und_loeschen'] + "? " + output['t_simulate_loadcart_hinweis']) + "</b></p>";
    }

    if (cart_load_private_cart_default_mode == 'add') {
        confirmText = "<p align='center'>" + output['t_wollen_sie_den_warenkorb_hinzufuegen'] + "?</p>";
    }

    if (cart_load_private_cart_default_mode == 'overwrite') {
        confirmText = "<p align='center'>" + output['t_wollen_sie_den_warenkorb_ueberschreiben'] + "?</p>";
    }


    var additional = "";
    if (publicCartAutoDelete) {
        additional = confirmText2;
    }
    var html = '<div class="confirmBox" id="confirmBox' + id + '">' +
        '<div class="boxTitle">' +
        '<span class="close"></span>' +
        confirmTitle +
        '</div>' +
        '<div class="boxContent">' +
        confirmText + additional +
        '</div>' +
        '<div class="boxButtons">';

    if (cart_load_private_cart_default_mode != "add" && cart_load_private_cart_default_mode != "overwrite") {
        html = html + '<button class="formButton overwrite" onclick="return false;">' + ((l_user['simulated_loadcart_mode'] == 'original' || !simulate) ? output['t_ueberschreiben'] : output['t_ueberschreiben_und_loeschen']) + '</button>';
        html = html + '<button class="formButton add" onclick="return false;">' + output['t_hinzufuegen'] + '</button>';
    } else {
        if ((l_user['simulated_loadcart_mode'] == "original" || !simulate) && cart_load_private_cart_default_mode == "add") {
            html = html + '<button class="formButton add" onclick="return false;">' + output['t_hinzufuegen'] + '</button>';
        }

        if ((l_user['simulated_loadcart_mode'] == "original" || !simulate) && cart_load_private_cart_default_mode == "overwrite") {
            html = html + '<button class="formButton overwrite" onclick="return false;">' + output['t_ueberschreiben'] + '</button>';
        }
    }

    html = html + '<button class="formButton cancel" onclick="return false;">' + output['t_abbrechen'] + '</button>' +
        '</div>' +
        '</div>';

    if ($(".confirmBox").length) {
        // dont show more than one confirmBox
        unloadConfirmBox();
    }
    $('body').append(html);
    var top = 0;
    if ($.browser.msie && $.browser.version < 8) {
        top = $(window).scrollTop();
        var height = $(window).innerHeight();
        $(".confirmBox").css("top", top - 500);
        $("#overDiv4").css('top', top);
        $("#overDiv4").height(height);
    }
    $(".confirmBox").animate({top: top, opacity: 1.0}, 500, 'swing');
    initConfirmBox(loadmultiplecarts);
}

/**
 *    FUNCTION TO SHOW CONFIRMBOX AND BIND BUTTON EVENTS
 */
function initConfirmBox(loadmultiplecarts) {
    $("#overDiv4").css({
        "display": "block",
        "visibility": "visible",
        "opacity": 0.0
    });
    $("#overDiv4").animate({"opacity": 0.5}, 800);

    $(window).keydown(function (e) {
        if ($(".confirmBox").is(":visible")) {
            if (e.keyCode == 27) {
                unloadConfirmBox();
            }
        }
    });

    // IE 6 und IE 7 do not support 'position:fixed' so the window 
    // needs to be positioned manually
    if ($.browser.msie && $.browser.version < 8) {
        $(window).scroll(function () {
            if ($(".confirmBox").is(":visible")) {
                var top = $(window).scrollTop();
                var height = window.innerHeight;
                $(".confirmBox").css('top', top);
                $("#overDiv4").css('top', top);
                $("#overDiv4").height(height);
                //$("#overDiv4").css({"filter":"(opacity=50)"});
            }
        });
    }
    $(".formButton.overwrite").click(function () {
        var id = $(this).parent().parent()[0].id.substr(10);
        unloadConfirmBox();
        okConfirm1(id, loadmultiplecarts);
    });
    $(".formButton.add").click(function () {
        var id = $(this).parent().parent()[0].id.substr(10);
        unloadConfirmBox();
        okConfirm2(id, loadmultiplecarts);
    });
    $(".formButton.cancel,span.close").click(function () {
        unloadConfirmBox();
    });
}

function getLoadCartIds() {
    var loadcartids_string = '';

    $("[name^=checkcart]:checked").each(function () {
        loadcartids_string = loadcartids_string + this.name.substring(9) + ';'
    });


    return loadcartids_string;
}

function oneLoadCartCheckboxChecked() {
    if ($("[name^=checkcart]").is(":checked"))
        return true;
    else
        return false;
}

function checkUncheckAllCheckboxes(prefix, check) {
    $("[id^=" + prefix + "]").each(function () {
        this.checked = (check) ? true : false;
    });
}

function unloadConfirmBox() {
    $(".formButton,span.close").unbind("click"); // unbind events
    $(".confirmBox").fadeOut("fast", function () {
        $(this).remove();
        // remove Container from DOM after fadeOut Animation has finished
    });
    $("#overDiv4").fadeOut();
}

function okConfirm1(id, loadmultiplecarts) {
    disablePageOnReload(output['t_warenkorb_wird_geladen']);
    loadSavedCart(id, "overwrite", loadmultiplecarts);
    return false;
}

function okConfirm2(id, loadmultiplecarts) {
    disablePageOnReload(output['t_warenkorb_wird_geladen']);
    loadSavedCart(id, "add", loadmultiplecarts);
    return false;
}

/***********************/
/***** maketip.js ******/
/***********************/

// Bubblehelp infoboxes, (C) 2002 Klaus Knopper <infobox@knopper.net>
// You can copy/modify and distribute this code under the conditions
// of the GNU GENERAL PUBLIC LICENSE Version 2.
//
//
// Changes by Knito:
// 2005-10-15: Changed: maketip()
//             New: getScrollXY(), setCookie()
//
var ns6         // Arw we using Netscape6? // Knito
var ns4         // Are we using Netscape4?
var ie4         // Are we using Internet Explorer Version 4?
var ie5         // Are we using Internet Explorer Version 5 and up?
var ie7					// are we using Internet Explorer Version 7
var ie8					// are we using Internet Explorer Version 8
var ie9					// are we using Internet Explorer Version 9
var kon         // Are we using KDE Konqueror?
var opera       // Are we using Opera?

var x, y, winW, winH, imgHeight, imgWidth  // Current help position and main window size
var idiv = null   // Pointer to infodiv container
var idiv1 = null  // helper for iframe-hack
var px = "px"     // position suffix with "px" in some cases

function nsfix() {
    setTimeout("window.onresize = rebrowse", 2000);
}

function rebrowse() {
    window.location.reload();
}

function hascss() {
    return gettip('infodiv') ? true : false
}

function infoinit() {
    ns6 = (document.getElementById && !document.all) ? true : false;
    ns4 = (document.layers) ? true : false;
    ie4 = (document.all) ? true : false;
    ie5 = ((ie4) && ((navigator.userAgent.indexOf('MSIE 5') > 0) || (navigator.userAgent.indexOf('MSIE 6') > 0))) ? true : false;
    ie7 = ((ie4) && (navigator.userAgent.indexOf('MSIE 7') > 0)) ? true : false;
    ie8 = ((ie4) && (navigator.userAgent.indexOf('MSIE 8') > 0)) ? true : false;
    ie9 = ((ie4) && (navigator.userAgent.indexOf('MSIE 9') > 0)) ? true : false;
    kon = (navigator.userAgent.indexOf('konqueror') > 0) ? true : false;

    opera = (navigator.userAgent.indexOf("Opera") != -1) ? true : false;

    x = 0;
    y = 0;
    winW = 800;
    winH = 600;
    idiv = null;
    document.onmousemove = mousemove;
    if (ns4 && document.captureEvents)
        document.captureEvents(Event.MOUSEMOVE);
    // Workaround for just another netscape bug: Fix browser confusion on resize
    // obviously conqueror has a similar problem :-(
    if (ns4 || kon || opera) {
        nsfix()
    }
    if (ns4) {
        px = "";
    }
}

function untip() {
    if (idiv)
        idiv.visibility = ns4 ? "hide" : "hidden";
    idiv = null;

    // also hide the iframe underneath the <div>
    //
    /*idivif=document.getElementById('infodivif');
     if (idivif) {
     idivif.style.visibility = "hidden";
     }
     */

}

function gettip(name) {

    return (document.layers && document.layers[name]) ? document.layers[name] : (document.all && document.all[name] && document.all[name].style) ? document.all[name].style : document[name] ? document[name] : (document.getElementById(name) ? document.getElementById(name).style : 0);
}

// Prepare tip boxes, but don't show them yet
function maketip(name, title, text) {
    // this function replaces the original infobox.js::maketip()
    if (hascss())
        document.write('<div id=\"' + name + '\" class=\"infobox\" name=\"' + name + '\" style=\"width:auto;\"><div class=\"infoboxbody\"><img class="articleImage2" src="' + text + '" id="img_' + name + '"><\/div><\/div>');
}

function showtip() {
    // this function replaces the original infobox.js::showtip() which was loaded before
    // using getScrollXY() it is capable of respecting scrolled positions
    // knito - at - knito - dot - de 2005-03-03 http://www.ingoknito.de

    var xy;
    xy = getScrollXY();
    /* offSet - how far has user scrolled */

    /* DIG code */
    idiv.left = (((x + imgWidth + 15) < winW) ? x + 12 : x - imgWidth) + px;
    idiv.top = (((y + imgHeight + 20) < winH) ? y + 12 : y - imgHeight) + xy[1] + px;

    idiv.visibility = ns4 ? "show" : "visible";
}

function tip(name) {
    console.log('tip was called');
    if (hascss()) {
        if (idiv)
            untip();
        idiv = gettip(name);
        if (ie4 || ie5) {
            idiv1 = document.getElementById(name);
        }
        if (idiv) {
            if (typeof (window.innerWidth) == 'number') {
                //Non-IE
                winW = window.innerWidth;
                winH = window.innerHeight;
            } else if (document.documentElement && (document.documentElement.clientWidth || document.documentElement.clientHeight)) {
                //IE 6+ in 'standards compliant mode'
                winW = document.documentElement.clientWidth;
                winH = document.documentElement.clientHeight;
            } else if (document.body && (document.body.clientWidth || document.body.clientHeight)) {
                //IE 4 compatible
                winW = document.body.clientWidth;
                winH = document.body.clientHeight;
            }

            /* BA: not original code! */
            imgHeight = document.getElementById('img_' + name).height;
            imgWidth = document.getElementById('img_' + name).width;

            if (x <= 0 || y <= 0) { // konqueror can't get mouse position
                x = (winW - imgWidth) / 2 + (window.pageXOffset ? window.pageXOffset : 0);
                y = (winH - 50) / 2 + (window.pageYOffset ? window.pageYOffset : 0); // middle of window
            }

            showtip();
        }
    }
}

function getScrollXY() {
    var scrOfX = 0, scrOfY = 0;
    if (opera || typeof (window.pageYOffset) == 'number') {
        //Netscape compliant
        scrOfY = 0; // window.pageYOffset;
        scrOfX = 0; // window.pageXOffset;
    } else if (document.body && (document.body.scrollLeft || document.body.scrollTop)) {
        //DOM compliant
        scrOfY = document.body.scrollTop;
        scrOfX = document.body.scrollLeft;
    } else if (document.documentElement && (document.documentElement.scrollLeft || document.documentElement.scrollTop)) {
        //IE6 standards compliant mode
        scrOfY = document.documentElement.scrollTop;
        scrOfX = document.documentElement.scrollLeft;
    }
    return [scrOfX, scrOfY];
}


function mousemove(e) {
    if (e) {
        x = e.pageX ? e.pageX : e.clientX ? e.clientX : 0;
        y = e.pageY ? e.pageY : e.clientY ? e.clientY : 0;
    } else if (event) {
        x = event.clientX;
        y = event.clientY;
    } else {
        x = 0;
        y = 0;
    }
    if ((ie4 || ie5) && document.documentElement && !(ie7 || ie8 || ie9)) // Workaround for scroll offset of IE 4,5,6
    {
        x += document.documentElement.scrollLeft;
        y += document.documentElement.scrollTop;
    }
    if (idiv)
        showtip(name);
}


function showAstrasCartCartarticle(cart_id, mode) {
    if (mode == 'Y') {
        toggleBox('astrascart_detailrow_show_' + cart_id, 0);
        toggleBox('astrascart_detailrow_hide_' + cart_id, 1);
        $.ajax
        (
            {
                url: "ajax-backend/showAstrasCartCartarticle.php?astrascartid=" + cart_id,
                type: 'post',
                data: "sid=" + sid,
                success: function (data) {
                    var astrascart_detailrow = $("#astrascart_detailrow_" + cart_id);
                    $(astrascart_detailrow).parent().parent().show();
                    $(astrascart_detailrow).slideUp(0);
                    $(astrascart_detailrow).html(data).slideDown("slow");
                }
            }
        );
    } else if (mode == 'N') {
        toggleBox('astrascart_detailrow_show_' + cart_id, 1);
        toggleBox('astrascart_detailrow_hide_' + cart_id, 0);

        $("#astrascart_detailrow_" + cart_id).slideUp("fast", function () {
            $(this).html("");
            $(this).parent().parent().hide();
        });
    }
}

function showConfirmAstras(id, cart_auto_delete) {
    var confirmTitle = "<p align='center'><b>" + output['t_sicherheitsabfrage'] + "</b></p>";
    var confirmText = "<p align='center'>" + output['t_wollen_sie_den_warenkorb_ueberschreiben_hinzufuegen'] + "?</p>";
    var confirmText2 = "<p><center>" + output['t_achtung_warenkorb_kann_nur_einmal_verwendet_werden'] + "</center></p>";

    var additional = "";
    if (cart_auto_delete) {
        additional = confirmText2;
    }
    var html = '<div class="confirmBox" id="confirmBox' + id + '">' +
        '<div class="boxTitle">' +
        '<span class="close"></span>' +
        confirmTitle +
        '</div>' +
        '<div class="boxContent">' +
        confirmText + additional +
        '</div>' +
        '<div class="boxButtons">' +
        '<button class="formButton overwrite" onclick="return false;">' + output['t_ueberschreiben'] + '</button>' +
        '<button class="formButton add" onclick="return false;">' + output['t_hinzufuegen'] + '</button>' +
        '<button class="formButton cancel" onclick="return false;">' + output['t_abbrechen'] + '</button>' +
        '</div>' +
        '</div>';

    if ($(".confirmBox").length) {
        // dont show more than one confirmBox
        unloadConfirmBox();
    }
    $('body').append(html);
    var top = 0;
    if ($.browser.msie && $.browser.version < 8) {
        top = $(window).scrollTop();
        var height = $(window).innerHeight();
        $(".confirmBox").css("top", top - 500);
        $("#overDiv4").css('top', top);
        $("#overDiv4").height(height);
    }
    $(".confirmBox").animate({top: top, opacity: 1.0}, 500, 'swing');
    initConfirmBox(false);
}


/********************/
/****** ajax.js *****/
/********************/

/* Simple AJAX Code-Kit (SACK) v1.6.1 */
/* ©2005 Gregory Wild-Smith */
/* www.twilightuniverse.com */

/* Software licenced under a modified X11 licence,
 see documentation or authors website for more details */

function sack(file) {
    this.xmlhttp = null;

    this.resetData = function () {
        this.method = "POST";
        this.queryStringSeparator = "?";
        this.argumentSeparator = "&";
        this.URLString = "";
        this.encodeURIString = true;
        this.execute = false;
        this.element = null;
        this.elementObj = null;
        this.requestFile = file;
        this.vars = new Object();
        this.responseStatus = new Array(2);
    };

    this.resetFunctions = function () {
        this.onLoading = function () {
        };
        this.onLoaded = function () {
        };
        this.onInteractive = function () {
        };
        this.onCompletion = function () {
        };
        this.onError = function () {
        };
        this.onFail = function () {
        };
    };

    this.reset = function () {
        this.resetFunctions();
        this.resetData();
    };

    this.createAJAX = function () {
        try {
            this.xmlhttp = new ActiveXObject("Msxml2.XMLHTTP");
        } catch (e1) {
            try {
                this.xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
            } catch (e2) {
                this.xmlhttp = null;
            }
        }

        if (!this.xmlhttp) {
            if (typeof XMLHttpRequest != "undefined") {
                this.xmlhttp = new XMLHttpRequest();
            } else {
                this.failed = true;
            }
        }
    };

    this.setVar = function (name, value) {
        this.vars[name] = Array(value, false);
    };

    this.encVar = function (name, value, returnvars) {
        if (true == returnvars) {
            return Array(encodeURIComponent(name), encodeURIComponent(value));
        } else {
            this.vars[encodeURIComponent(name)] = Array(encodeURIComponent(value), true);
        }
    }

    this.processURLString = function (string, encode) {
        encoded = encodeURIComponent(this.argumentSeparator);
        regexp = new RegExp(this.argumentSeparator + "|" + encoded);
        varArray = string.split(regexp);
        for (i = 0; i < varArray.length; i++) {
            urlVars = varArray[i].split("=");
            if (true == encode) {
                this.encVar(urlVars[0], urlVars[1]);
            } else {
                this.setVar(urlVars[0], urlVars[1]);
            }
        }
    }

    this.createURLString = function (urlstring) {
        if (this.encodeURIString && this.URLString.length) {
            this.processURLString(this.URLString, true);
        }

        if (urlstring) {
            if (this.URLString.length) {
                this.URLString += this.argumentSeparator + urlstring;
            } else {
                this.URLString = urlstring;
            }
        }

        // prevents caching of URLString
        this.setVar("rndval", new Date().getTime());

        urlstringtemp = new Array();
        for (key in this.vars) {
            if (false == this.vars[key][1] && true == this.encodeURIString) {
                encoded = this.encVar(key, this.vars[key][0], true);
                delete this.vars[key];
                this.vars[encoded[0]] = Array(encoded[1], true);
                key = encoded[0];
            }

            urlstringtemp[urlstringtemp.length] = key + "=" + this.vars[key][0];
        }
        if (urlstring) {
            this.URLString += this.argumentSeparator + urlstringtemp.join(this.argumentSeparator);
        } else {
            this.URLString += urlstringtemp.join(this.argumentSeparator);
        }
    }

    this.runResponse = function () {
        eval(this.response);
    }

    this.runAJAXSynchronous = function (urlstring) {
        if (this.failed) {
            this.onFail();
        } else {
            this.createURLString(urlstring);
            if (this.element) {
                this.elementObj = document.getElementById(this.element);
            }
            if (this.xmlhttp) {
                var self = this;
                if (this.method == "GET") {
                    totalurlstring = this.requestFile + this.queryStringSeparator + this.URLString;
                    this.xmlhttp.open(this.method, totalurlstring, false);
                } else {
                    this.xmlhttp.open(this.method, this.requestFile, false);
                    try {
                        this.xmlhttp.setRequestHeader("Content-Type", "application/x-www-form-urlencoded")
                    } catch (e) {
                    }
                }

                this.xmlhttp.onreadystatechange = function () {
                    switch (self.xmlhttp.readyState) {
                        case 1:
                            self.onLoading();
                            break;
                        case 2:
                            self.onLoaded();
                            break;
                        case 3:
                            self.onInteractive();
                            break;
                        case 4:
                            self.response = self.xmlhttp.responseText;
                            self.responseXML = self.xmlhttp.responseXML;
                            self.responseStatus[0] = self.xmlhttp.status;
                            self.responseStatus[1] = self.xmlhttp.statusText;

                            if (self.execute) {
                                self.runResponse();
                            }

                            if (self.elementObj) {
                                elemNodeName = self.elementObj.nodeName;
                                elemNodeName.toLowerCase();
                                if (elemNodeName == "input"
                                    || elemNodeName == "select"
                                    || elemNodeName == "option"
                                    || elemNodeName == "textarea") {
                                    self.elementObj.value = self.response;
                                } else {
                                    self.elementObj.innerHTML = self.response;
                                }
                            }
                            if (self.responseStatus[0] == "200") {
                                self.onCompletion();
                            } else {
                                self.onError();
                            }

                            self.URLString = "";
                            break;
                    }
                };

                this.xmlhttp.send(this.URLString);
            }
        }
    }

    this.runAJAX = function (urlstring) {
        if (this.failed) {
            this.onFail();
        } else {
            this.createURLString(urlstring);
            if (this.element) {
                this.elementObj = document.getElementById(this.element);
            }
            if (this.xmlhttp) {
                var self = this;
                if (this.method == "GET") {
                    totalurlstring = this.requestFile + this.queryStringSeparator + this.URLString;
                    this.xmlhttp.open(this.method, totalurlstring, true);
                } else {
                    this.xmlhttp.open(this.method, this.requestFile, true);
                    try {
                        this.xmlhttp.setRequestHeader("Content-Type", "application/x-www-form-urlencoded")
                    } catch (e) {
                    }
                }

                this.xmlhttp.onreadystatechange = function () {
                    switch (self.xmlhttp.readyState) {
                        case 1:
                            self.onLoading();
                            break;
                        case 2:
                            self.onLoaded();
                            break;
                        case 3:
                            self.onInteractive();
                            break;
                        case 4:
                            self.response = self.xmlhttp.responseText;
                            self.responseXML = self.xmlhttp.responseXML;
                            self.responseStatus[0] = self.xmlhttp.status;
                            self.responseStatus[1] = self.xmlhttp.statusText;

                            if (self.execute) {
                                self.runResponse();
                            }

                            if (self.elementObj) {
                                elemNodeName = self.elementObj.nodeName;
                                elemNodeName.toLowerCase();
                                if (elemNodeName == "input"
                                    || elemNodeName == "select"
                                    || elemNodeName == "option"
                                    || elemNodeName == "textarea") {
                                    self.elementObj.value = self.response;
                                } else {
                                    self.elementObj.innerHTML = self.response;
                                }
                            }
                            if (self.responseStatus[0] == "200") {
                                self.onCompletion();
                            } else {
                                self.onError();
                            }

                            self.URLString = "";
                            break;
                    }
                };

                this.xmlhttp.send(this.URLString);
            }
        }
    };

    this.reset();
    this.createAJAX();
}

function openReportingNG(myid, mysrc) {
    setAktivClass('dyn_reporting_' + myid);

    if ($.browser.msie === true && $.browser.version === '9.0') {
        toggleBox('reporting_old_div', 0);
        toggleBox('reporting_new_div', 0);
        toggleBox('reporting_new_div_ie9', 1);

        window.open(mysrc, 'reportingWindow', 'width=900,height=700,resizable=yes,scrollbars=yes,toolbar=no,location=no,directories=no,status=no,menubar=no,copyhistory=no');
    } else {
        toggleBox('reporting_old_div', 0);
        toggleBox('reporting_new_div_ie9', 0);
        toggleBox('reporting_new_div', 1);

        document.getElementById('reporting_new_iframe').src = mysrc;
    }
}

function getOpener() {
    debugger;
    if (opener) {
        var myopener = opener;
    } else if (window.opener) {
        var myopener = window.opener;
    } else if (self.opener) {
        var myopener = self.opener;
    }

    return myopener;
}

function checkContractStartEndDate(cartarticleIdsString) {
    var ok = true;
    cartarticleIdsString = cartarticleIdsString + '';
    var cartarticleIds = cartarticleIdsString.split(';');

    var currentDateTime = new Date();
    var todayMonth = currentDateTime.getMonth() + 1;
    var todayDay = currentDateTime.getDate();
    var todayYear = currentDateTime.getFullYear();
    var todayDateString = todayMonth + '/' + todayDay + '/' + todayYear;
    var today = new Date(todayDateString);

    for (i = 0; i < cartarticleIds.length; i++) {
        var contractStartRaw = document.getElementById('contract_start_date' + cartarticleIds[i]).value;
        var contractEndRaw = document.getElementById('contract_end_date' + cartarticleIds[i]).value;
        var contractStartDateTmp = parseDateFromCalendar(contractStartRaw);
        var contractEndDateTmp = parseDateFromCalendar(contractEndRaw);

        var contractStartDate = new Date(contractStartDateTmp);
        var contractEndDate = new Date(contractEndDateTmp);

        //if (contractEndDate < contractStartDate || today > contractStartDate || today > contractEndDate || contractStartRaw == '' || contractEndRaw == '') {
        if (contractEndDate < contractStartDate ||  today > contractEndDate || contractStartRaw == '' || contractEndRaw == '') {
            ok = false;
        }
    }

    if (ok === false) {
        alert(output['t_kein_gueltiges_datum_ausgewaehlt']);
    }

    return ok;
}


function addOption(selectId, optionText, optionValue) {
    var select = document.getElementById(selectId);
    var newOption = new Option(optionText, optionValue);
    select.options[select.length] = newOption;
}

function handleDropDownState(checkBox, dropDownName) {
    if (checkBox.checked) {
        $(dropDownName).removeAttr("disabled");
    } else {
        $(dropDownName).attr("disabled", "disabled");
    }
}

function getAdditionalLocationApprovers(locationApprovalCounter, dropDownName) {
    var selectedValues = '';
    var addSemicolon = false;
    for (i = 0; i < locationApprovalCounter; i++) {
        var selValue = $('select[name=' + dropDownName + i.toString() + ']');
        if (selValue.val() !== 0 && selValue.is(':enabled')) {
            if (addSemicolon) {
                selectedValues += ';';
            }
            selectedValues += selValue.val();
            addSemicolon = true;
        }
    }

    return (selectedValues != '') ? selectedValues : false;

}

function openPopup(a, id) {
    //Get the screen height and width
    var maskHeight = $(document).height();
    var maskWidth = $(window).width();

    //Set heigth and width to mask to fill up the whole screen
    $('#mask').css({'width': maskWidth, 'height': maskHeight});

    //transition effect		
    $('#mask').fadeIn(1000);
    $('#mask').fadeTo("slow", 0.8);

    //Get the window height and width
    var winH = $(window).height();
    var winW = $(window).width();

    //Set the popup window to center
    $(id).css('top', winH / 2 - $(id).height() / 2);
    $(id).css('left', winW / 2 - $(id).width() / 2);

    //transition effect
    $(id).fadeIn(2000);
}


function updateLocationIdForCartId() {

    /*
     document.cartform.displaymenu.value='cart'; 
     document.cartform.updatecartlocationid.value='Y';
     submitFormGreyOut(document.cartform);
     */
    var className = "cart";
    var methodName = "setLocation";

    var success = function () {

        updateHeadCartInfo(
            "location",
            "getDefaultCostcenterIdByLocationId",
            function (e) {
                var object = jQuery.parseJSON(e);
                if (object.default_costcenter_id !== null) {
                    if ($("[name='billto_location_id'] option[value='" + object.default_costcenter_id + "']").length == 0) {
                        displayAjaxError("DefaultCostCenterId not in List. " + object.default_costcenter_id);
                    } else {
                        $("[name='billto_location_id']").first().val(object.default_costcenter_id);
                    }
                    updateBillToLocationIdForCartId();

                }
            },
            function (e) {
                displayAjaxError("failure getDefaultCostcenterIdByLocationId");
            }
        )

    }

    updateHeadCartInfo(className, methodName, success, function () {
        displayAjaxError("failure updateLocationIdForCartId");
    });

}


function displayAjaxError(message) {

    alert("AJAX FEHLER: " + message);
}

function updateHeadCartInfo(className, methodName, success, error) {

    var locationId = $("[name='location_id']").first().val();
    var billToLocationId = $("[name='billto_location_id']").first().val();
    var locationSubId = $("[name='location_sub_id']").first().val();

    var showCartId = $("#cartFormPointer").children("[name='showcartid']").first().val();
    var receiverWebuserId = $("[name='receiver_webuser_id']").first().val();

    $.ajax
    (
        {
            contentType: "application/json; charset=utf-8",
            url: "ajax/handler_new.php?class=" + className + "&method=" + methodName,
            type: 'post',
            data: JSON.stringify({
                'class': className,
                'method': methodName,
                'sid': sid,
                'locationId': locationId,
                'showCartId': showCartId,
                'receiverWebuserId': receiverWebuserId,
                'locationSubId': locationSubId,
                'billToLocationId': billToLocationId
            }),
            dataType: 'json',
            success: success,
            error: error
        }
    );
}


function updateBillToLocationIdForCartId() {
    var className = "cart";
    var methodName = "setBillToLocation";

    var success = function () {
    }

    updateHeadCartInfo(className, methodName, success, function () {
        displayAjaxError("failure updateBillToLocationIdForCartId");
    });
}

function updateReceiverWebuserIdByCartId() {
    var className = "cart";
    var methodName = "setCartReceiver";

    var success = function (e) {

        var object = jQuery.parseJSON(e);

        if (object.preselectedLocationSub !== null) {
            if ($("[name='location_sub_id'] option[value='" + object.preselectedLocationSub + "']").length == 0) {
                displayAjaxError("LocationSub Preselect not in List " + object.preselectedLocationSub);
            } else {
                alert(object.preselectedLocationSub);
                $("[name='location_sub_id']").first().val(object.preselectedLocationSub);
            }
        }

        updateHeadCartInfo(
            "location",
            "getDefaultCostcenterIdByLocationId",
            function (e) {
                var object = jQuery.parseJSON(e);
                if (object.default_costcenter_id != null) {

                    $("[name='billto_location_id']").first().val(object.default_costcenter_id);
                    updateBillToLocationIdForCartId();

                }
            },
            function (e) {
                displayAjaxError("failure getDefaultCostcenterIdByLocationId");
            }
        )

    }

    updateHeadCartInfo(className, methodName, success, function () {
        displayAjaxError("failure updateReceiverWebuserIdByCartId");
    });
}


function updateLocationSubIdForCartId() {
    var className = "cart";
    var methodName = "setLocationSub";

    var success = function () {

        updateHeadCartInfo(
            "location",
            "getReceiverWebusersByLocationId",
            function (e) {
                var object = jQuery.parseJSON(e);

                $("[name='receiver_webuser_id']").first().html("");

                jQuery.each(object, function (index, value) {

                    $("[name='receiver_webuser_id']").first().append("<option value='" + value.id + "'>" + value.name + "</option>");

                });
            },
            function (e) {
                displayAjaxError("failure getReceiverWebusersByLocationId");
            }
        )

    }

    updateHeadCartInfo(className, methodName, success, function () {
        displayAjaxError("failure updateLocationSubIdForCartId");
    });
}


function userErelContrloll(id) {
    if (id) {
        id = '_' + id;
    } else {
        id = '';
    }
    var erel = $('#userSendErel' + id).is(':checked');
    var banf = $('#isBanfOnlyEnabled' + id).is(':checked');


    $('#userNoErelPost' + id).val(!erel);
    if (banf) {
        $('#userSendErel' + id).attr("disabled", true).attr("checked", false);
        $('#userNoErelPost' + id).val(true);
    } else {
        $('#userSendErel' + id).attr("disabled", false);
    }
}


/**
 *
 * @ Validate Email
 * @ Author: joga, 07.04.2015
 *
 */
function emailValidation(email) {
    var emailPattern = /\b[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,4}\b/;
    return emailPattern.test(email);
}

function updateErpgroupbuyer(value) {
    submitFormGreyOut(document.cartform);
}


function openEXTProject(url) {
    window.location.assign(url);
}

function resizeIframe(obj) {
    obj.style.height = obj.contentWindow.document.body.scrollHeight + 'px';
}


function updateExportTemplateCatalog(data) {
    var timer = setInterval(function () {
        AjaxHandlerByClass(
            'ajax/Administration/Catalog/updatedCatalogDownload',
            data,
            function (response_data) {
                var exportCatalogTemplate = {};
                exportCatalogTemplate.result = oJSFunc.getObj('result', response_data);
                exportCatalogTemplate.done_rows = oJSFunc.getObj('done_rows', response_data);
                exportCatalogTemplate.total_rows = oJSFunc.getObj('total_rows', response_data);
                exportCatalogTemplate.msg = oJSFunc.getObj('total_rows', response_data);
                switch (exportCatalogTemplate.result) {
                    // Starting download
                    case('Done'):
                        notification.info(output['m_queue_progress_message_download']);
                        var filename = oJSFunc.getObj('link', response_data);
                        window.open('download/download_xls.php?sid=' + sid + '&type=template&file=' + filename);
                        clearInterval(timer);
                        enablePageOnDataLoad();
                        break;
                    // Genarating Content
                    case('InProgress'):
                        notification.info(output['m_queue_progress_message_genarating'] + " " + exportCatalogTemplate.done_rows + "/" + exportCatalogTemplate.total_rows);
                        break;
                    // Data gathering is in process...
                    case('PreparingQuery'):
                        notification.info(output['m_queue_progress_message_gathering'] + " " + exportCatalogTemplate.done_rows + "/" + exportCatalogTemplate.total_rows);
                        break;
                    // Network error, retrying...
                    default:
                        notification.info(output['m_queue_progress_message_networkerr']);
                        break;
                }
            },
            function (xhr, ajaxOptions, thrownError) {
                notification.error(output['m_error_when_export']);
            }
        );
    }, 5000);
}


function insertCssRule(rule, index) {
    var sheet = window.document.styleSheets[0];
    if (sheet.cssRules) {
        document.styleSheets[0].insertRule(rule, 0);
    } else if (sheet.rules) { //ie
        document.styleSheets[0].addRule(rule, 0);
    }
}

function togglePalfingerAssignment(divName, checkbox) {
    if (checkbox.checked)
        Ext.get(divName).hide();
    else
        Ext.get(divName).show();
}

function submitFormGreyOut(theform) {
    disablePageOnDataLoad();
    theform.submit();
}

